const en = {
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.close": "Close",
    "common.ok": "Ok",
    "common.save": "Save",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.open": "Open",
    "common.create": "Create",
    "common.update": "Update",
    "common.confirm": "Confirm",
    "common.verify": "Verify",
    "common.email": "Email",
    "common.password": "Password",
    "common.loading": "Loading...",
    "common.notSet": "—",
    "common.enabled": "Enabled",
    "common.disabled": "Disabled",
    "common.verified": "Verified",
    "common.notVerified": "Not verified",
    "common.yes": "Yes",
    "common.no": "No",
    "common.required": "This field is required.",
    "common.info": "Info",
    "common.adminOnly": "Only Admin Access",

    "nav.accountMenu": "Account menu",
    "nav.settings": "Settings",
    "nav.logout": "Logout",

    "menu.general": "GENERAL",
    "menu.transport": "TRANSPORT",
    "menu.calculations": "TOOLS",
    "menu.admin": "ADMIN",
    "menu.dashboard": "Dashboard",
    "menu.posts": "Posts",
    "menu.customers": "Customers",
    "menu.vehicles": "Vehicles",
    "menu.drivers": "Drivers",
    "menu.contacts": "Contacts",
    "menu.addresses": "Addresses",
    "menu.cargo": "Cargo",
    "menu.company": "Company",
    "menu.freights": "Freights",
    "menu.settlements": "Settlements",
    "menu.agentAi": "Agent AI",
    "menu.users": "Users",
    "menu.alerts": "Alerts",

    "footer.subtitle": "software by GAINSOFT",
    "footer.support": "Technical support",
    "footer.reportBug": "Report a bug",
    "footer.copyright": "Powered by GAINSOFT ©, 2026",

    "login.intro": "Transport-Spedycja-Logistyka is a workspace for carriers, forwarders, and logistics teams. It keeps operational updates, alerts, and account administration in one place, so the people moving freight can share what changed and act on it sooner.",
    "login.poweredBy": "Powered by GAINSOFT ©",

    "auth.signIn": "Sign in",
    "auth.signInSubtitle": "Use your standard or admin TSL account from AWS Cognito.",
    "auth.login": "Login",
    "auth.forgotPassword": "Forgot password",
    "auth.emailRequired": "Email is required.",
    "auth.passwordRequired": "Password is required.",
    "auth.confirmEmail": "Confirm email",
    "auth.confirmEmailSubtitle": "Enter the code sent to {email}.",
    "auth.yourEmail": "your email",
    "auth.confirmationCode": "Confirmation code",
    "auth.resendCode": "Resend code",
    "auth.sms": "Text message (SMS)",
    "auth.totp": "Google Authenticator",
    "auth.chooseVerification": "Choose verification",
    "auth.chooseVerificationSubtitle": "Select how to confirm this sign-in.",
    "auth.setupVerification": "Set up verification",
    "auth.setupVerificationSubtitle": "MFA is required. Choose SMS or Google Authenticator.",
    "auth.setupSms": "Set up SMS",
    "auth.setupSmsRequired": "Enter your mobile number. We will text a code to turn on SMS verification.",
    "auth.setupSmsOptional": "Cognito texts the verified phone number saved on your account. Add it in international format when you create the account.",
    "auth.phoneInvalid": "Enter a phone number in international format, for example +48123456789.",
    "auth.phone": "Phone number",
    "auth.sendCode": "Send code",
    "auth.verificationCode": "Verification code",
    "auth.setupTotp": "Set up Google Authenticator",
    "auth.setupTotpSubtitle": "Scan the QR code, or enter the key manually, then type the 6-digit code.",
    "auth.qrAlt": "QR code for Google Authenticator",
    "auth.authenticatorCode": "Authenticator code",
    "auth.newPassword": "Choose a new password",
    "auth.newPasswordSubtitle": "Your account needs a new password before you can continue.",
    "auth.newPasswordLabel": "New password",
    "auth.confirmPassword": "Confirm password",
    "auth.passwordsMismatch": "Ensure passwords match.",
    "auth.savePassword": "Save password",
    "auth.resetPassword": "Reset password",
    "auth.resetPasswordSubtitle": "We will email you a code to choose a new password.",
    "auth.resetCodeSent": "Enter the code sent to {destination}.",
    "auth.resetCodeFallback": "Enter the code from your email and a new password.",
    "auth.resetCode": "Reset code",
    "auth.updatePassword": "Update password",
    "auth.codeAndPasswordRequired": "Code and password are required.",
    "auth.smsCode": "SMS code",
    "auth.enterCodeSent": "Enter the code sent to {destination}.",
    "auth.enterCode": "Enter the code.",
    "auth.totpCode": "Authenticator code",
    "auth.totpCodeSubtitle": "Enter the 6-digit code from Google Authenticator.",
    "auth.notice.confirmationSent": "A new confirmation code has been sent.",
    "auth.notice.smsSent": "A new SMS code has been sent.",
    "auth.notice.passwordUpdated": "Password updated. Sign in with the new password.",
    "auth.error.generic": "Something went wrong.",
    "auth.error.secretHash": "This app client has a client secret. In Cognito, create a public app client without a secret and put its client id in .env.local.",
    "auth.error.incorrectCredentials": "Incorrect email or password.",
    "auth.error.confirmEmail": "Confirm your email before signing in.",
    "auth.error.invalidCode": "That code is invalid. Try again.",
    "auth.error.expiredCode": "That code has expired. Request a new one.",
    "auth.error.emailExists": "An account with this email already exists.",
    "auth.error.tooManyAttempts": "Too many attempts. Wait a moment and try again.",
    "auth.error.smsPool": "This user pool cannot send SMS yet. In Cognito, open Messaging and set an SNS role for SMS, or choose Google Authenticator instead.",
    "auth.error.notConfigured": "Cognito is not configured. Add the user pool id and app client id to .env.local.",
    "auth.error.noSession": "Sign-in did not return a session.",
    "auth.error.smsSetup": "Cognito did not send an SMS code. The phone number on this account must be verified, and SMS MFA must be enabled in the user pool. You can set up Google Authenticator instead.",

    "register.title": "Create account",
    "register.description": "Fill the form to register. We will email you a confirmation code.",
    "register.emailInvalid": "Enter a valid email.",
    "register.phoneInvalid": "Phone number must use international format, for example +48123456789.",
    "register.phoneHint": "Optional. Required later if you choose SMS verification.",

    "page.notFound": "Page not found ... ",
    "page.maintenanceTitle": "Maintenance work of TSL is in progress.",
    "page.maintenanceSubtitle": "Thank you for your understanding.",

    "theme.title": "Theme",
    "theme.copy": "Switch between light and dark. The choice is saved in this browser.",
    "theme.dark": "Dark",
    "theme.light": "Light",
    "theme.switchToLight": "Switch to light mode",
    "theme.switchToDark": "Switch to dark mode",

    "language.title": "Language",
    "language.copy": "Choose the application language. The choice is saved in this browser.",
    "language.english": "English",
    "language.polish": "Polski",
    "language.switchToEnglish": "Switch to English",
    "language.switchToPolish": "Switch to Polish",

    "timezone.title": "Time zone",
    "timezone.copy": "On a local server, times follow this computer. On the UTC server, dates are shown in this time zone and saved as UTC.",
    "timezone.label": "Time zone",
    "timezone.london": "Europe, London",
    "timezone.berlin": "Europe, Berlin",
    "timezone.warsaw": "Europe, Warsaw",
    "timezone.helsinki": "Europe, Helsinki",

    "settings.accountNote": "All information comes from your Cognito account.",
    "settings.account": "Account",
    "settings.changePassword": "Change password",
    "settings.changePasswordCopy": "After clicking the button, you will be signed out and the reset page will open. Enter your email, then use the code we send to your email to choose a new password.",
    "settings.userId": "User ID (local database)",
    "settings.username": "Username",
    "settings.created": "Created",
    "settings.lastUpdate": "Last Update",
    "settings.phone": "Phone",
    "settings.phoneVerified": "Phone Verified",
    "settings.emailVerified": "Email Verified",
    "settings.mfa": "MFA",
    "settings.mfaSms": "SMS",
    "settings.mfaAuthenticator": "Authenticator",

    "user.title": "User",
    "user.readOnly": "Account details are read-only.",
    "user.id": "User ID",
    "user.username": "Username",
    "user.confirmation": "Confirmation status",
    "user.created": "Created",
    "user.updated": "Last update",
    "user.mfa": "MFA",
    "user.enabled": "Enabled",
    "user.role": "Role",
    "user.cannotDeleteSelf": "You cannot delete your account from this view. Go to Settings.",
    "user.deleteTitle": "Delete User",
    "user.deleteMany": "Are you sure want to delete {count} users?",
    "user.deleteOne": "Are You sure want to delete user {name} ?",

    "posts.title": "Posts",
    "posts.intro": "Announcements visible to everyone. Add a post, or select a row to edit or delete it.",
    "posts.create": "Add new post",
    "posts.updateTitle": "Update Post",
    "posts.createTitle": "Create Post",
    "posts.description": "Create or update post. This will be visible for all users.",
    "posts.titleLabel": "Title",
    "posts.titlePlaceholder": "Post title",
    "posts.content": "Content",
    "posts.contentPlaceholder": "Write post ...",
    "posts.deleteTitle": "Delete Post",
    "posts.deleteMany": "Are you sure want to delete {count} posts?",
    "posts.deleteOne": "Are you sure want to delete post with ID '{id}' ?",

    "customers.title": "Customers",
    "customers.intro": "This is the customer register. Add a customer, open a name to see that customer, or select a row to delete it.",
    "customers.add": "Add new Customer",
    "customers.createHint": "Name, entity type, status, roles, language and timezone are required. Website and status note are optional.",
    "customers.choose": "Choose",
    "customers.rolesPlaceholder": "principal, shipper",
    "customers.exampleName": "ABC Logistics sp. z o.o.",
    "customers.exampleWebsite": "https://abc.example",
    "customers.exampleStatusNote": "Active customer.",
    "customers.exampleTaxId": "5251234567",
    "customers.exampleVatEu": "PL5251234567",
    "customers.exampleRegon": "012345678",
    "customers.exampleKrs": "0000123456",
    "customers.exampleCountry": "PL",
    "customers.exampleInvoiceEmail": "faktury@abc.pl",
    "customers.exampleCurrency": "PLN",
    "customers.examplePaymentTerms": "30",
    "customers.examplePaymentMethod": "bank_transfer",
    "customers.exampleIban": "PL61109010140000071219812874",
    "customers.exampleFullName": "Anna Kowalska",
    "customers.exampleJobTitle": "Transport Manager",
    "customers.exampleDepartment": "Logistics",
    "customers.exampleEmail": "anna.kowalska@abc.pl",
    "customers.examplePhone": "+48600123456",
    "customers.exampleLocationType": "warehouse, loading",
    "customers.exampleAddressName": "Central warehouse",
    "customers.exampleNameAtSite": "ABC Logistics DC Pruszkow",
    "customers.exampleStreet": "Logistyczna",
    "customers.exampleBuilding": "12",
    "customers.exampleUnit": "A",
    "customers.examplePostalCode": "05-800",
    "customers.exampleCity": "Pruszkow",
    "customers.exampleRegion": "mazowieckie",
    "customers.exampleLatitude": "52.1657",
    "customers.exampleLongitude": "20.8031",
    "customers.exampleOpeningHours": "Mon-Fri 06:00-22:00",
    "customers.exampleLoading": "45",
    "customers.exampleUnloading": "30",
    "customers.exampleDriver": "Gate 2, report to the office.",
    "customers.examplePpe": "helmet, vest",
    "customers.exampleHeight": "4",
    "customers.rolesRequired": "Enter at least one role.",
    "customers.websiteInvalid": "Website must be an http or https URL.",
    "customers.entityType": "Entity type",
    "customers.roles": "Roles",
    "customers.website": "Website",
    "customers.language": "Language",
    "customers.timezone": "Timezone",
    "customers.statusNote": "Status note",
    "customers.legal": "Registration",
    "customers.contacts": "Contacts",
    "customers.addresses": "Addresses",
    "customers.noLegal": "No registration data.",
    "customers.noContacts": "No contacts.",
    "customers.noAddresses": "No addresses.",
    "customers.taxId": "Tax ID",
    "customers.vatEu": "EU VAT",
    "customers.regon": "REGON",
    "customers.krs": "KRS",
    "customers.country": "Country",
    "customers.vatStatus": "VAT status",
    "customers.invoiceEmail": "Invoice email",
    "customers.currency": "Currency",
    "customers.paymentTerms": "Payment terms (days)",
    "customers.paymentMethod": "Payment method",
    "customers.iban": "IBAN",
    "customers.fullName": "Name",
    "customers.jobTitle": "Job title",
    "customers.department": "Department",
    "customers.phone": "Phone",
    "customers.locationType": "Location type",
    "customers.street": "Street",
    "customers.city": "City",
    "customers.openingHours": "Opening hours",
    "customers.appointment": "Appointment required",
    "customers.driverInstructions": "Driver instructions",
    "customers.legalTitle": "Legal information",
    "customers.legalHint": "Registration and billing fields: tax id, VAT, REGON, KRS, country, currency, payment terms and IBAN.",
    "customers.contactsHint": "People at the customer: name, job title, department, email and phone. You can add more than one.",
    "customers.contactsReadHint": "Edit these people on the Contacts page.",
    "customers.addressesHint": "Offices and sites: street, city, country, opening hours and driver instructions. You can add more than one.",
    "customers.addressesReadHint": "Edit these places on the Addresses page.",
    "customers.addItem": "Add new",
    "customers.building": "Building",
    "customers.unit": "Unit",
    "customers.postalCode": "Postal code",
    "customers.region": "Region",
    "customers.nameAtSite": "Name at site",
    "customers.latitude": "Latitude",
    "customers.longitude": "Longitude",
    "customers.loadingTime": "Loading time (min)",
    "customers.unloadingTime": "Unloading time (min)",
    "customers.ppe": "PPE",
    "customers.active": "Active",
    "customers.vehicleMega": "Mega trailer",
    "customers.vehicleHeight": "Max height (m)",
    "customers.vehicleNight": "Night entry",
    "customers.countryRequired": "Country is required when you fill in legal or address data.",
    "customers.countryInvalid": "Country must be a two-letter code, for example PL.",
    "customers.contactNameRequired": "Each contact needs a name.",
    "customers.numberInvalid": "Enter a valid number.",
    "customers.deleteTitle": "Delete customer",
    "customers.deleteMany": "Are you sure you want to delete {count} customers?",
    "customers.deleteOne": "Are you sure you want to delete customer '{name}'?",
    "company.title": "Company",
    "company.emptyDescription": "There is no company profile yet. Add the legal name, then fill in registration data, contacts and addresses.",
    "company.add": "Add company information",
    "company.licenses": "Licenses",
    "company.insurances": "Insurance",
    "company.licensesHint": "Road-transport licenses: type, number, validity and the issuing authority.",
    "company.insurancesHint": "Carrier, motor and cargo policies: insurer, number, cover and validity.",
    "company.noLicenses": "No licenses.",
    "company.noInsurances": "No insurance policies.",
    "company.licenseType": "License type",
    "company.licenseNumber": "License number",
    "company.issuedOn": "Issued on",
    "company.validUntil": "Valid until",
    "company.validFrom": "Valid from",
    "company.authority": "Issuing authority",
    "company.vehicleLimit": "Vehicle limit",
    "company.notes": "Notes",
    "company.policyType": "Policy type",
    "company.policyNumber": "Policy number",
    "company.insurer": "Insurer",
    "company.coverage": "Coverage amount",
    "company.licenseRequired": "Each license needs a type and a number.",
    "company.policyRequired": "Each policy needs a type and a number.",
    "company.dateInvalid": "Enter a date as YYYY-MM-DD.",
    "company.license.domestic": "Domestic",
    "company.license.community": "Community",
    "company.license.cabotage": "Cabotage",
    "company.policy.carrier_liability": "Carrier liability (OCP)",
    "company.policy.motor": "Motor",
    "company.policy.cargo": "Cargo",
    "customer.entity.company": "Company",
    "customer.entity.sole_trader": "Sole trader",
    "customer.entity.person": "Person",
    "customer.status.active": "Active",
    "customer.status.blocked": "Blocked",
    "customer.status.archived": "Archived",
    "customer.language.pl": "Polish",
    "customer.language.en": "English",
    "customer.language.de": "German",
    "customer.vat.active": "Active",
    "customer.vat.exempt": "Exempt",
    "customer.vat.unknown": "Unknown",

    "vehicles.title": "Vehicles",
    "vehicles.intro": "This is the fleet register. Add a vehicle, open a registration number to edit it, or select a row to delete it.",
    "vehicles.add": "Add new Vehicle",
    "vehicles.createHint": "Registration, kind, name and status are required. Fleet code and notes are optional.",
    "vehicles.choose": "Choose",
    "vehicles.registration": "Registration",
    "vehicles.fleetCode": "Fleet code",
    "vehicles.kind": "Kind",
    "vehicles.hauledUnit": "Hauled vehicle",
    "vehicles.motorTitle": "Motor vehicles",
    "vehicles.hauledTitle": "Semitrailers and trailers",
    "vehicles.assignedMotor": "Assigned motor vehicle",
    "vehicles.name": "Name",
    "vehicles.exampleRegistration": "WGM 10101",
    "vehicles.exampleFleet": "T-01",
    "vehicles.exampleName": "Volvo FH 500",
    "vehicles.exampleNote": "Tractor on the PL-DE line.",
    "trailers.title": "Semitrailers",
    "trailers.intro": "Semitrailers have a cargo body and a kingpin. They have no engine, no fuel figure and no driver.",
    "trailers.add": "Add semitrailer",
    "trailers.createHint": "Registration, name and status are required. Fleet code and notes are optional.",
    "trailers.exampleName": "Schmitz SCS 24",
    "trailers.technicalHint": "Body, load space and kingpin.",
    "trailers.kingpin": "Kingpin height (mm)",
    "trailers.fifthWheel": "Fifth-wheel load (kg)",
    "trailers.deleteTitle": "Delete semitrailer",
    "trailers.deleteMany": "Are you sure you want to delete {count} semitrailers?",
    "trailers.deleteOne": "Are you sure you want to delete semitrailer '{name}'?",
    "drawbars.title": "Drawbar trailers",
    "drawbars.intro": "A drawbar trailer is pulled by a hitch, not a fifth wheel. It has no engine and no driver.",
    "drawbars.add": "Add drawbar trailer",
    "drawbars.createHint": "Registration, name and status are required. The coupling is edited on the trailer card.",
    "drawbars.technicalHint": "Body, load space and drawbar.",
    "drawbars.couplingTitle": "Coupling",
    "drawbars.couplingHint": "Turntable or central-axle drawbar.",
    "drawbars.noCoupling": "No coupling yet.",
    "drawbars.couplingType": "Coupling",
    "drawbars.drawbarLength": "Drawbar length (m)",
    "drawbars.hitchHeight": "Hitch height (mm)",
    "drawbars.deleteTitle": "Delete drawbar trailer",
    "drawbars.deleteMany": "Are you sure you want to delete {count} drawbar trailers?",
    "drawbars.deleteOne": "Are you sure you want to delete drawbar trailer '{name}'?",
    "drawbar.coupling.turntable": "Turntable",
    "drawbar.coupling.central_axle": "Central axle",
    "vehicles.dateInvalid": "Use a date as YYYY-MM-DD.",
    "vehicles.numberInvalid": "Enter a valid number.",
    "vehicles.addItem": "Add new",
    "vehicles.deleteTitle": "Delete vehicle",
    "vehicles.deleteMany": "Are you sure you want to delete {count} vehicles?",
    "vehicles.deleteOne": "Are you sure you want to delete vehicle '{name}'?",
    "vehicles.technicalTitle": "Technical profile",
    "vehicles.technicalHint": "Euro class, axles, weights and outer dimensions.",
    "vehicles.noTechnical": "No technical profile yet.",
    "vehicles.fuelTitle": "Fuel profile",
    "vehicles.fuelHint": "Fuel, AdBlue and consumption with a load, empty and on average.",
    "vehicles.noFuel": "No fuel profile yet.",
    "vehicles.operationalTitle": "Operations",
    "vehicles.operationalHint": "Home base and GPS.",
    "vehicles.noOperational": "No operational profile yet.",
    "vehicles.costsTitle": "Costs",
    "vehicles.costsHint": "Fixed costs, period budget and the last invoice.",
    "vehicles.noCosts": "No cost record yet.",
    "vehicles.assignmentsTitle": "Semitrailer and trailer assignments",
    "vehicles.assignmentsHint": "Couple one semitrailer to a tractor, or one trailer to a rigid. The motor vehicle becomes ready. A driver name replaces that status.",
    "vehicles.assignHauled": "Assign semitrailer or trailer",
    "vehicles.assignBlocked": "A vehicle in status '{status}' cannot take a semitrailer or trailer.",
    "vehicles.noAssignments": "No semitrailer or trailer assignment yet.",
    "vehicles.vanNoCoupling": "A van is not coupled to a semitrailer or trailer.",
    "vehicles.bodyType": "Body type",
    "vehicles.euroClass": "Euro class",
    "vehicles.axles": "Axles",
    "vehicles.grossWeight": "Gross weight (kg)",
    "vehicles.curbWeight": "Curb weight (kg)",
    "vehicles.payload": "Payload (kg)",
    "vehicles.length": "Length (m)",
    "vehicles.width": "Width (m)",
    "vehicles.height": "Height (m)",
    "vehicles.loadingMeters": "Loading meters",
    "vehicles.pallets": "Pallet places",
    "vehicles.volume": "Volume (m3)",
    "vehicles.tailLift": "Tail lift",
    "vehicles.adr": "ADR",
    "vehicles.temperature": "Temperature controlled",
    "vehicles.tempMin": "Min temperature (C)",
    "vehicles.tempMax": "Max temperature (C)",
    "vehicles.fuelType": "Fuel type",
    "vehicles.tank": "Tank (l)",
    "vehicles.adblueTank": "AdBlue tank (l)",
    "vehicles.consumption": "Average consumption (l/100 km)",
    "vehicles.consumptionLoaded": "Full load (l/100 km)",
    "vehicles.consumptionEmpty": "Empty (l/100 km)",
    "vehicles.adblueUse": "AdBlue (l/100 km)",
    "vehicles.homeBase": "Home base",
    "vehicles.gps": "GPS tracking",
    "vehicles.notes": "Notes",
    "vehicles.currency": "Currency",
    "vehicles.period": "Budget period",
    "vehicles.leasingCost": "Leasing cost",
    "vehicles.insuranceCost": "Insurance cost",
    "vehicles.fixedCost": "Fixed costs",
    "vehicles.budget": "Budget",
    "vehicles.invoiceNumber": "Last invoice",
    "vehicles.invoiceDate": "Invoice date",
    "vehicles.driver": "Driver",
    "vehicles.phone": "Phone",
    "vehicles.assignedFrom": "Assignment date",
    "vehicles.assignedTo": "To",
    "vehicles.current": "Current",
    "vehicle.kind.tractor": "Tractor",
    "vehicle.kind.rigid": "Rigid",
    "vehicle.kind.trailer": "Trailer",
    "vehicle.kind.semitrailer": "Semitrailer",
    "vehicle.kind.van": "Van",
    "vehicle.status.available": "Available",
    "vehicle.status.workshop": "Workshop",
    "vehicle.status.unavailable": "Unavailable",
    "vehicle.status.busy": "Busy",
    "vehicle.status.ready": "Ready",
    "vehicle.body.curtainsider": "Curtainsider",
    "vehicle.body.box": "Box",
    "vehicle.body.refrigerated": "Refrigerated",
    "vehicle.body.tanker": "Tanker",
    "vehicle.body.flatbed": "Flatbed",
    "vehicle.body.container": "Container",
    "vehicle.body.other": "Other",
    "vehicle.fuel.diesel": "Diesel",
    "vehicle.fuel.lng": "LNG",
    "vehicle.fuel.cng": "CNG",
    "vehicle.fuel.electric": "Electric",
    "vehicle.fuel.hybrid": "Hybrid",
    "vehicle.period.monthly": "Monthly",
    "vehicle.period.yearly": "Yearly",

    "contact.role.dispatcher": "Dispatcher",
    "contact.role.security": "Security",
    "contact.role.other": "Other",

    "contacts.title": "Contacts",
    "contacts.intro": "People at a customer: dispatchers, security and others. A freight stop uses one of these contacts.",
    "contacts.add": "Add contact",
    "contacts.createHint": "Role, the person and email are required. Company and phone are optional.",
    "contacts.editHint": "Update this person. Freight stops that use the contact show the new details.",
    "contacts.customer": "Affiliation",
    "contacts.company": "Affiliation",
    "contacts.role": "Role",
    "contacts.exampleRole": "Dispatcher",
    "contacts.fullName": "Full name",
    "contacts.phone": "Phone",
    "contacts.email": "Email",
    "contacts.notes": "Notes",
    "contacts.choose": "Choose",
    "contacts.deleteTitle": "Delete contact",
    "contacts.deleteOne": "Delete {name}?",
    "contacts.deleteMany": "Delete {count} contacts?",

    "addresses.title": "Addresses",
    "addresses.intro": "Permanent sites for customers and the company: warehouses, offices and loading points.",
    "addresses.location.loading": "Loading",
    "addresses.location.unloading": "Unloading",
    "addresses.location.headquarters": "Headquarters",
    "addresses.openFrom": "Open from",
    "addresses.openTo": "Open to",
    "addresses.status.open": "Open",
    "addresses.status.closed": "Closed",
    "addresses.add": "Add address",
    "addresses.createHint": "Country is required. Assign the address to a customer or the company, or leave it unassigned.",
    "addresses.editHint": "Update this place. The customer or company card shows the same address.",
    "addresses.party": "Affiliation",
    "addresses.choose": "Choose",
    "addresses.deleteTitle": "Delete address",
    "addresses.deleteOne": "Delete {name}?",
    "addresses.deleteMany": "Delete {count} addresses?",

    "cargo.title": "Cargo",
    "cargo.intro": "Goods that can be assigned to a freight: packaging, weight and ADR details.",
    "cargo.add": "Add cargo",
    "cargo.createHint": "Description is required. Packaging defaults to a pallet.",
    "cargo.editHint": "Update this cargo. Freights that use it show the same details.",
    "cargo.choose": "Choose",
    "cargo.deleteTitle": "Delete cargo",
    "cargo.deleteOne": "Delete {name}?",
    "cargo.deleteMany": "Delete {count} cargo items?",

    "drivers.title": "Drivers",
    "drivers.intro": "People in the fleet: contact details, contract and vehicle assignments.",
    "drivers.add": "Add new driver",
    "drivers.createHint": "Identity and contact details. Employment and assignments are edited on the driver page.",
    "drivers.choose": "Choose",
    "drivers.addItem": "Add row",
    "drivers.deleteTitle": "Delete driver",
    "drivers.deleteOne": "Delete {name}?",
    "drivers.deleteMany": "Delete {count} drivers?",
    "drivers.employeeCode": "Employee code",
    "drivers.fullName": "Full name",
    "drivers.assignedVehicle": "Assigned vehicle",
    "drivers.firstName": "First name",
    "drivers.lastName": "Last name",
    "drivers.phone": "Phone",
    "drivers.email": "Email",
    "drivers.country": "Country",
    "drivers.language": "Languages",
    "drivers.exampleCode": "D-04",
    "drivers.examplePhone": "+48500100101",
    "drivers.exampleCountry": "PL",
    "drivers.exampleLanguages": "PL, ENG",
    "drivers.languageInvalid": "Each language is a 2 or 3 letter code, for example PL or ENG.",
    "drivers.numberInvalid": "Enter a number.",
    "drivers.dateInvalid": "Use the date format YYYY-MM-DD.",
    "drivers.countryInvalid": "Country is a two-letter code, for example PL.",
    "drivers.employmentTitle": "Employment",
    "drivers.employmentHint": "Contract, home base and the daily net rate.",
    "drivers.noEmployment": "No employment record.",
    "drivers.contractNumber": "Contract number",
    "drivers.jobTitle": "Job title",
    "drivers.homeBase": "Home base",
    "drivers.currency": "Currency",
    "drivers.dailyRate": "Daily rate",
    "drivers.notes": "Notes",
    "drivers.metricsTitle": "KPIs",
    "drivers.metricsHint": "Violations, fuel and damage.",
    "drivers.noMetrics": "No KPI record.",
    "drivers.violations": "Violations",
    "drivers.lastChecked": "Last check",
    "drivers.fuel": "Fuel l/100 km",
    "drivers.damages": "Damage count",
    "drivers.current": "Current",
    "drivers.assignmentsTitle": "Vehicle assignments",
    "drivers.assignmentsHint": "Assign a ready motor vehicle. Its status then becomes this driver's name.",
    "drivers.assignVehicle": "Assign vehicle",
    "drivers.assignBlocked": "A driver in status '{status}' cannot be assigned a vehicle.",
    "drivers.noAssignments": "No assignments.",
    "drivers.registration": "Registration",
    "drivers.vehicleSet": "Combination",
    "drivers.order": "Order",
    "drivers.assignedFrom": "Assignment date",
    "drivers.assignedTo": "To",
    "driver.status.available": "Available",
    "driver.status.unavailable": "Unavailable",
    "driver.status.ready": "Ready",

    "alerts.title": "Alerts",
    "alerts.deleteTitle": "Delete Alert",
    "alerts.deleteMany": "Are you sure want to delete {count} alerts?",
    "alerts.deleteOne": "Are you sure want to delete alert with ID '{id}' ?",

    "dashboard.route.origin": "Origin address",
    "dashboard.route.destination": "Destination address",
    "dashboard.route.originPlaceholder": "Street number, Postal code City",
    "dashboard.route.destinationPlaceholder": "Street number, Postal code City",
    "dashboard.cargo.settings": "Cargo settings",
    "dashboard.cargo.loadingAt": "Loading date and time",
    "dashboard.cargo.unloadingAt": "Unloading date and time",
    "dashboard.cargo.loadingTime": "Loading time (min)",
    "dashboard.cargo.unloadingTime": "Unloading time (min)",
    "dashboard.route.settings": "Route settings",
    "dashboard.route.performingVehicle": "Vehicle on this route",
    "dashboard.route.driver": "Driver",
    "dashboard.route.noDriver": "No driver",
    "dashboard.route.point": "Address",
    "dashboard.route.pointPlaceholder": "Street number, Postal code City",
    "dashboard.route.addPoint": "Add a point",
    "dashboard.route.removePoint": "Remove point",
    "dashboard.route.dragPoint": "Drag point",
    "dashboard.route.noMatch": "No matching address",
    "dashboard.route.noFreight": "No matching freight",
    "dashboard.route.noVehicle": "No vehicle",
    "dashboard.route.vehicle": "Vehicle",
    "dashboard.route.selectVehicle": "Select",
    "dashboard.route.bus": "Bus",
    "dashboard.route.truck": "Truck",
    "dashboard.route.calculate": "Calculate route",
    "dashboard.route.historyColumn": "Calculated routes",
    "dashboard.route.noHistory": "No saved routes",
    "dashboard.route.deleteTitle": "Delete route",
    "dashboard.route.sendToDriver": "Send route to the driver",
    "dashboard.route.sendConfirm": "Send this route to {name}?",
    "dashboard.route.sendGoogle": "On Google Maps",
    "dashboard.route.sendHere": "On HERE WeGo",
    "dashboard.route.hereTruckLicense": "Truck navigation in HERE WeGo requires a HERE WeGo Pro license on the driver's phone. Without it the app shows a car route.",
    "dashboard.route.sending": "Sending...",
    "dashboard.route.sent": "The route was sent to the driver.",
    "dashboard.route.sendFailed": "The route could not be sent.",
    "dashboard.route.deleteOne": "Are you sure you want to delete the route '{name}'?",
    "dashboard.route.deleteMany": "Are you sure you want to delete {count} routes?",
    "dashboard.route.calculating": "Calculating...",
    "dashboard.route.distance": "Distance: {distance} km",
    "dashboard.route.summaryRoute": "Route",
    "dashboard.route.summaryLeg": "Leg",
    "dashboard.route.summaryDistance": "Distance",
    "dashboard.route.summaryDuration": "Time",
    "dashboard.route.estimatedArrival": "Estimated arrival",
    "dashboard.route.estimatedUnloadingEnd": "Estimated unloading end",
    "dashboard.route.plannedUnloading": "Versus planned unloading",
    "dashboard.route.arrivalOnTime": "On time",
    "dashboard.route.arrivalLate": "{duration} late",
    "dashboard.route.arrivalEarly": "{duration} early",
    "dashboard.route.summaryToll": "Toll",
    "dashboard.route.variant": "Route {number} — Option {mode}",
    "dashboard.route.mode.fast": "fast",
    "dashboard.route.mode.short": "short",
    "dashboard.route.tolls": "Road tolls",
    "dashboard.route.noTolls": "No tolls",
    "dashboard.route.distanceValue": "{distance} km",
    "dashboard.route.durationHours": "Time: {hours} h {minutes} min",
    "dashboard.route.durationHoursValue": "{hours} h {minutes} min",
    "dashboard.route.durationMinutes": "Time: {minutes} min",
    "dashboard.route.durationMinutesValue": "{minutes} min",
    "dashboard.route.mapUnavailable": "The map is unavailable.",
    "dashboard.route.switchMapToDay": "Switch the map to day",
    "dashboard.route.switchMapToNight": "Switch the map to night",
    "dashboard.route.openPoint": "Address of point {letter}",
    "dashboard.route.pointTitle": "Point {letter}",
    "dashboard.route.matchedAddress": "Matched place",
    "dashboard.route.pointCoordinates": "Coordinates",

    "table.edit": "Edit",
    "table.delete": "Delete",
    "table.deleteRecords": "Delete records",

    "col.id": "ID",
    "col.title": "Title",
    "col.enabled": "Enabled",
    "col.role": "Role",
    "col.email": "Email",
    "col.status": "Status",
    "col.createdShort": "Created",
    "col.updatedShort": "Last Update",
    "col.name": "Name",
    "col.messageId": "Message ID",
    "col.dateSent": "Date sent",
    "col.actions": "Actions",

    "code.admin": "Admin",
    "code.standard": "Standard",
    "code.confirmed": "Confirmed",
    "code.unconfirmed": "Unconfirmed",
    "code.archived": "Archived",
    "code.compromised": "Compromised",
    "code.unknown": "Unknown",
    "code.reset_required": "Reset required",
    "code.force_change_password": "Force change password",
    "code.external_provider": "External provider",

    "documents.title": "Documents",
    "documents.hint": "Files stored for this record.",
    "documents.drop": "Drop files here, or choose them from disk.",
    "documents.choose": "Choose files",
    "documents.upload": "Upload",
    "documents.download": "Download",
    "documents.downloadFailed": "The file could not be downloaded.",
    "documents.remove": "Remove",
    "documents.tooMany": "You can add up to 10 files.",
    "documents.duplicate": "This file is already loaded.",
    "documents.tooLarge": "A file is larger than 20 MB.",
    "documents.uploadFailed": "Upload failed. Try again.",
    "documents.status.selected": "Ready to upload",
    "documents.deleteTitle": "Delete file",
    "documents.deleteOne": "Are you sure you want to delete '{name}'?",
    "documents.deleteMany": "Are you sure you want to delete {count} files?",

    "settlements.title": "Settlements",
    "settlements.intro": "Upload invoices and receipts as PDF, JPG, or PNG, then calculate the amount to pay, the net amount, VAT and service hours. Up to 10 files, 10 MB each. Fuel settlement still accepts PDF only.",
    "settlements.disabled": "Settlements are turned off.",
    "settlements.drop": "Drop PDF, JPG, or PNG files here, or choose them from disk.",
    "settlements.choose": "Choose files",
    "settlements.upload": "Upload",
    "settlements.settle": "Settle",
    "settlements.name": "Name",
    "settlements.namePlaceholder": "September fuel",
    "settlements.taskType": "Type",
    "settlements.select": "Choose",
    "settlements.detailType": "Settlement type",
    "settlements.created": "Created",
    "settlements.completed": "Completed",
    "settlements.task.rozliczenia": "Invoice settlement",
    "settlements.task.rozliczenia_faktur": "Invoice settlement",
    "settlements.task.rozliczenia_paliwa": "Fuel settlement",
    "settlements.waiting": "Calculation in progress",
    "settlements.uploadFailed": "Upload failed. Try again.",
    "settlements.settleFailed": "Settlement failed.",
    "settlements.tooMany": "You can add at most 10 files.",
    "settlements.duplicate": "This file is already loaded.",
    "settlements.onlyPdf": "Only PDF, JPG, JPEG, and PNG files are accepted.",
    "settlements.fuelPdfOnly": "Fuel settlement accepts PDF files only.",
    "settlements.tooLarge": "Each file must be between 1 byte and 10 MB.",
    "settlements.remove": "Remove",
    "settlements.history": "History",
    "settlements.deleteTitle": "Delete settlement",
    "settlements.deleteOne": "Are you sure you want to delete settlement '{name}'?",
    "settlements.deleteMany": "Are you sure you want to delete {count} settlements?",
    "settlements.empty": "No settlements yet.",
    "settlements.result": "Result",
    "settlements.total": "Total",
    "settlements.gross": "Gross",
    "settlements.net": "Net",
    "settlements.vat": "VAT",
    "settlements.hours": "Hours",
    "settlements.serviceHours": "Service hours",
    "settlements.hoursValue": "{hours} h",
    "settlements.missing": "Missing documents",
    "settlements.status.selected": "Ready to upload",
    "settlements.status.uploaded": "Uploaded",
    "settlements.jobStatus.processing": "Processing",
    "settlements.jobStatus.completed": "Completed",
    "settlements.jobStatus.failed": "Failed",
    "settlements.error.provider_error": "The calculation service did not return a result.",
    "settlements.error.invalid_result": "The calculation result could not be read.",

    "freights.title": "Freights",
    "freights.intro": "Road freight orders. Add an order, open its number to edit it, or select a row to delete it.",
    "freights.add": "Add new freight",
    "freights.createHint": "Order number, status, price and currency are required. External reference and notes are optional.",
    "freights.choose": "Choose",
    "freights.number": "Order number",
    "freights.external": "External reference",
    "freights.notes": "Notes",
    "freights.exampleNumber": "ZL/2026/1044",
    "freights.exampleExternal": "PO-4401",
    "freights.exampleNote": "FTL Warsaw to Berlin.",
    "freights.datetimeInvalid": "Use a date as YYYY-MM-DD or YYYY-MM-DDTHH:MM:SS.",
    "freights.unloadingBeforeLoading": "Unloading date and time must be later than the loading date and time.",
    "freights.numberInvalid": "Enter a valid number.",
    "freights.countryInvalid": "Country code must be 2 letters.",
    "freights.addItem": "Add new",
    "freights.deleteTitle": "Delete freight",
    "freights.deleteMany": "Are you sure you want to delete {count} freights?",
    "freights.deleteOne": "Are you sure you want to delete freight '{name}'?",
    "freights.stopsTitle": "Stops",
    "freights.stopsHint": "Loading, unloading, customs and rest points. The person on site is a contact: name, role, phone, email and customer.",
    "freights.noStops": "No stops yet.",
    "freights.cargoTitle": "Cargo",
    "freights.cargoHint": "Assign cargo from the catalog. Packaging, weight and ADR stay on the cargo card.",
    "freights.assignCargo": "Assign cargo",
    "freights.addCargo": "Add new cargo",
    "freights.noCargoMatch": "No matching cargo",
    "freights.dragCargo": "Drag cargo",
    "freights.removeCargo": "Remove cargo",
    "freights.noCargo": "No cargo assigned yet.",
    "freights.loadingAt": "Loading date and time",
    "freights.unloadingAt": "Unloading date and time",
    "freights.requirementTitle": "Requirements",
    "freights.requirementHint": "Vehicle, driver and execution requirements.",
    "freights.noRequirement": "No requirements yet.",
    "freights.commercialTitle": "Commercial terms",
    "freights.commercialHint": "Payment term and waiting time.",
    "freights.noCommercial": "No commercial terms yet.",
    "freights.routeTitle": "Route plan",
    "freights.routeHint": "Legs with paid kilometres, empty kilometres, time and toll.",
    "freights.noRoute": "No route legs yet.",
    "freights.customersTitle": "Customer",
    "freights.customersHint": "Assign the customer this freight belongs to.",
    "freights.assignCustomer": "Assign customer",
    "freights.noCustomers": "No customer assigned yet.",
    "freights.driversTitle": "Drivers",
    "freights.driversHint": "Assign a ready driver. Their current vehicle is the freight vehicle. The freight moves to in transit and the driver status becomes this order number. Setting the freight to draft or planned unassigns the driver and sets them back to ready.",
    "freights.assignDriver": "Assign driver",
    "freights.noDrivers": "No drivers assigned yet.",
    "freights.executionTitle": "Execution",
    "freights.executionHint": "Actual loading, departure, delivery and delay.",
    "freights.noExecution": "No execution record yet.",
    "freights.estimatesTitle": "Planned costs",
    "freights.estimatesHint": "Estimated cost lines for this run.",
    "freights.noEstimates": "No planned costs yet.",
    "freights.actualsTitle": "Actual costs",
    "freights.actualsHint": "Costs recorded after the run.",
    "freights.noActuals": "No actual costs yet.",
    "freights.claimsTitle": "Claims",
    "freights.claimsHint": "Damage, delay, shortage or another charge.",
    "freights.noClaims": "No claims yet.",
    "freights.sequence": "Sequence",
    "freights.stopType": "Stop type",
    "freights.contact": "Contact",
    "freights.contactName": "Contact name",
    "freights.contactRole": "Role",
    "freights.contactPhone": "Phone",
    "freights.contactEmail": "Email",
    "freights.stopCustomer": "Customer",
    "freights.stopName": "Place name",
    "freights.street": "Street",
    "freights.postalCode": "Postal code",
    "freights.city": "City",
    "freights.country": "Country",
    "freights.plannedArrival": "Planned arrival",
    "freights.plannedDeparture": "Planned departure",
    "freights.instructions": "Instructions",
    "freights.description": "Description",
    "freights.packaging": "Packaging",
    "freights.quantity": "Quantity",
    "freights.weight": "Weight (kg)",
    "freights.volume": "Volume (m3)",
    "freights.loadingMeters": "Loading meters",
    "freights.adrInfo": "ADR details",
    "freights.unNumber": "UN number",
    "freights.packingGroup": "Packing group",
    "freights.vehicleKind": "Vehicle kind",
    "freights.bodyType": "Body type",
    "freights.requiresAdr": "ADR required",
    "freights.tailLift": "Tail lift required",
    "freights.minPayload": "Min payload (kg)",
    "freights.driverLanguage": "Driver language",
    "freights.price": "Price",
    "freights.currency": "Currency",
    "freights.paymentDays": "Payment term (days)",
    "freights.waitingHours": "Free waiting hours",
    "freights.waitingRate": "Waiting rate",
    "freights.termsNote": "Terms note",
    "freights.origin": "Origin",
    "freights.destination": "Destination",
    "freights.distance": "Distance (km)",
    "freights.paidKm": "Paid km",
    "freights.emptyKm": "Empty km",
    "freights.duration": "Duration (min)",
    "freights.toll": "Toll",
    "freights.tollCurrency": "Toll currency",
    "freights.driverId": "Driver id",
    "freights.customerId": "Customer id",
    "freights.assignedFrom": "Assignment date",
    "freights.current": "Current",
    "freights.loadedAt": "Loaded at",
    "freights.departedAt": "Departed at",
    "freights.deliveredAt": "Delivered at",
    "freights.delayReason": "Delay reason",
    "freights.delayMinutes": "Delay (min)",
    "freights.delayCost": "Delay cost",
    "freights.delayCurrency": "Delay currency",
    "freights.costType": "Cost type",
    "freights.amount": "Amount",
    "freights.note": "Note",
    "freights.claimType": "Claim type",
    "freights.claimStatus": "Claim status",
    "freights.claimDescription": "Description",
    "freights.openedOn": "Opened on",
    "freights.closedOn": "Closed on",
    "freight.status.draft": "Draft",
    "freight.status.planned": "Planned",
    "freight.status.in_transit": "In transit",
    "freight.status.delivered": "Delivered",
    "freight.status.cancelled": "Cancelled",
    "freight.status.closed": "Closed",
    "freight.stop.loading": "Loading",
    "freight.stop.unloading": "Unloading",
    "freight.stop.customs": "Customs",
    "freight.stop.rest": "Rest",
    "freight.packaging.pallet": "Pallet",
    "freight.packaging.carton": "Carton",
    "freight.packaging.big_bag": "Big bag",
    "freight.packaging.container": "Container",
    "freight.packaging.other": "Other",
    "freight.cost.fuel": "Fuel",
    "freight.cost.toll": "Toll",
    "freight.cost.parking": "Parking",
    "freight.cost.driver": "Driver",
    "freight.cost.subcontract": "Subcontract",
    "freight.cost.other": "Other",
    "freight.claimType.damage": "Damage",
    "freight.claimType.delay": "Delay",
    "freight.claimType.shortage": "Shortage",
    "freight.claimType.other": "Other",
    "freight.claimStatus.open": "Open",
    "freight.claimStatus.accepted": "Accepted",
    "freight.claimStatus.rejected": "Rejected",
    "freight.claimStatus.closed": "Closed",

    "agent.title": "Agent AI",
    "agent.intro": "The agent calculates the profitability of the selected freight. It takes the price, kilometres, fuel, tolls, parking, pay and allowance from the TMS, and Perplexity calculates the cost and margin in EUR.",
    "agent.disabled": "Agent AI is turned off.",
    "agent.parameters": "Agent parameters",
    "agent.task": "Agent task",
    "agent.freight": "Freight",
    "agent.name": "Name",
    "agent.namePlaceholder": "October rates",
    "agent.select": "Choose",
    "agent.task.calculate_freight": "Calculate freight",
    "agent.startAt": "Start time",
    "agent.frequencyTitle": "Agent run frequency",
    "agent.frequencyHint": "The unit and the value set how often the agent repeats the calculation after the first run. For example, 10 minutes or 2 hours.",
    "agent.timeUnit": "Time unit",
    "agent.unit.minutes": "Minutes",
    "agent.unit.hours": "Hours",
    "agent.value": "Value",
    "agent.frequency": "Frequency",
    "agent.minutesCount": "{count} min",
    "agent.hoursCount": "{count} h",
    "agent.history": "History",
    "agent.deleteTitle": "Delete agent run",
    "agent.deleteOne": "Are you sure you want to delete agent run '{name}'?",
    "agent.deleteMany": "Are you sure you want to delete {count} agent runs?",
    "agent.deleteRunning": "Stop the agent before deleting a run that is still running.",
    "agent.result": "Result",
    "agent.resultTitle": "Result {id} for {name}",
    "agent.results": "Results",
    "agent.calculatedAt": "Calculated at",
    "agent.summary": "Summary",
    "agent.resultMissing": "This calculation could not be found.",
    "agent.lastRun": "Last run",
    "agent.noResult": "The calculation has not run yet.",
    "agent.missing": "This agent run could not be found.",
    "agent.revenue": "Revenue",
    "agent.fuel": "Fuel",
    "agent.toll": "Toll",
    "agent.parking": "Parking",
    "agent.salary": "Salary",
    "agent.allowance": "Allowance",
    "agent.cost": "Cost",
    "agent.margin": "Margin",
    "agent.marginPercent": "Margin %",
    "agent.status.scheduled": "Scheduled",
    "agent.status.running": "Running",
    "agent.status.stopped": "Stopped",
    "agent.error.provider_error": "The calculation service did not return a result.",
    "agent.error.invalid_result": "The calculation result could not be read.",
    "agent.start": "Start agent",
    "agent.stop": "Stop agent",
    "agent.started": "The agent is scheduled. The first run begins at the chosen time.",
    "agent.stopped": "The agent has been stopped.",
    "agent.running": "The agent is running.",
    "agent.failed": "The agent could not be started.",

    "menu.emailImport": "Mail import",
    "email.title": "Mail import",
    "email.intro": "Messages forwarded to the import address. A clean import creates a draft freight, visible under Freights.",
    "email.disabled": "Mail import is turned off.",
    "email.subject": "Subject",
    "email.sender": "Forwarder",
    "email.received": "Received",
    "email.attachments": "Attachments",
    "email.freight": "Freight",
    "email.openFreight": "Open freight",
    "email.noFreight": "No freight",
    "email.status.imported": "Imported",
    "email.status.rejected": "Rejected",
    "email.status.quarantine": "Quarantine",
    "email.reason.verdicts": "Security check",
    "email.reason.disabled_address": "Import address is disabled",
    "email.reason.too_large": "Message is too large",
    "email.reason.unparseable": "Message could not be read",
    "email.body": "Message",
    "email.htmlPreview": "HTML preview",
    "email.noBody": "This message has no text body.",
    "email.verdicts": "SES checks",
    "email.verdictsHint": "PASS is not a safety clearance.",
    "email.verdict.spamVerdict": "Spam",
    "email.verdict.virusVerdict": "Virus",
    "email.verdict.spfVerdict": "SPF",
    "email.verdict.dkimVerdict": "DKIM",
    "email.verdict.dmarcVerdict": "DMARC",
    "email.filename": "File",
    "email.type": "Type",
    "email.size": "Size",
    "email.download": "Download",
    "email.notDownloadable": "Not available",
    "email.downloadFailed": "The file could not be downloaded.",
    "email.missing": "This message could not be found.",
    "email.empty": "No imported messages yet.",
    "email.truncated": "Showing the latest {count} of {total}.",
    "email.originalId": "Original Message-ID",
    "email.fromMail": "Opened from imported mail",
};

const pl = {
    "common.back": "Wstecz",
    "common.cancel": "Anuluj",
    "common.close": "Zamknij",
    "common.ok": "Ok",
    "common.save": "Zapisz",
    "common.delete": "Usuń",
    "common.edit": "Edytuj",
    "common.open": "Otwórz",
    "common.create": "Utwórz",
    "common.update": "Aktualizuj",
    "common.confirm": "Potwierdź",
    "common.verify": "Zweryfikuj",
    "common.email": "E-mail",
    "common.password": "Hasło",
    "common.loading": "Ładowanie...",
    "common.notSet": "—",
    "common.enabled": "Włączone",
    "common.disabled": "Wyłączone",
    "common.verified": "Zweryfikowano",
    "common.notVerified": "Niezweryfikowano",
    "common.yes": "Tak",
    "common.no": "Nie",
    "common.required": "To pole jest wymagane.",
    "common.info": "Informacja",
    "common.adminOnly": "Tylko dla administratora",

    "nav.accountMenu": "Menu konta",
    "nav.settings": "Ustawienia",
    "nav.logout": "Wyloguj",

    "menu.general": "OGÓLNE",
    "menu.transport": "TRANSPORT",
    "menu.calculations": "NARZĘDZIA",
    "menu.admin": "ADMIN",
    "menu.dashboard": "Panel",
    "menu.posts": "Wpisy",
    "menu.customers": "Klienci",
    "menu.vehicles": "Pojazdy",
    "menu.drivers": "Kierowcy",
    "menu.contacts": "Kontakty",
    "menu.addresses": "Adresy",
    "menu.cargo": "Ładunki",
    "menu.company": "Firma",
    "menu.freights": "Frachty",
    "menu.settlements": "Rozliczenia",
    "menu.agentAi": "Agent AI",
    "menu.users": "Użytkownicy",
    "menu.alerts": "Alerty",

    "footer.subtitle": "producent oprogramowania GAINSOFT",
    "footer.support": "Pomoc techniczna",
    "footer.reportBug": "Zgłoś błąd",
    "footer.copyright": "Obsługiwane przez GAINSOFT ©, 2026",

    "login.intro": "Transport-Spedycja-Logistyka to miejsce pracy dla przewoźników, spedytorów i zespołów logistycznych. Aktualizacje operacyjne, alerty i administracja kontami są w jednym miejscu, żeby osoby obsługujące fracht mogły przekazać, co się zmieniło, i szybciej na to zareagować.",
    "login.poweredBy": "Powered by GAINSOFT ©",

    "auth.signIn": "Zaloguj się",
    "auth.signInSubtitle": "Użyj konta standardowego lub administratora TSL z AWS Cognito.",
    "auth.login": "Zaloguj",
    "auth.forgotPassword": "Nie pamiętam hasła",
    "auth.emailRequired": "E-mail jest wymagany.",
    "auth.passwordRequired": "Hasło jest wymagane.",
    "auth.confirmEmail": "Potwierdź e-mail",
    "auth.confirmEmailSubtitle": "Wpisz kod wysłany na {email}.",
    "auth.yourEmail": "Twój e-mail",
    "auth.confirmationCode": "Kod potwierdzający",
    "auth.resendCode": "Wyślij kod ponownie",
    "auth.sms": "Wiadomość SMS",
    "auth.totp": "Google Authenticator",
    "auth.chooseVerification": "Wybierz weryfikację",
    "auth.chooseVerificationSubtitle": "Wybierz sposób potwierdzenia tego logowania.",
    "auth.setupVerification": "Skonfiguruj weryfikację",
    "auth.setupVerificationSubtitle": "MFA jest wymagane. Wybierz SMS albo Google Authenticator.",
    "auth.setupSms": "Skonfiguruj SMS",
    "auth.setupSmsRequired": "Podaj numer telefonu. Wyślemy kod SMS, aby włączyć weryfikację SMS.",
    "auth.setupSmsOptional": "Cognito wysyła SMS na zweryfikowany numer zapisany na koncie. Podaj go w formacie międzynarodowym podczas tworzenia konta.",
    "auth.phoneInvalid": "Podaj numer w formacie międzynarodowym, na przykład +48123456789.",
    "auth.phone": "Numer telefonu",
    "auth.sendCode": "Wyślij kod",
    "auth.verificationCode": "Kod weryfikacyjny",
    "auth.setupTotp": "Skonfiguruj Google Authenticator",
    "auth.setupTotpSubtitle": "Zeskanuj kod QR albo wpisz klucz ręcznie, a następnie wpisz 6-cyfrowy kod.",
    "auth.qrAlt": "Kod QR dla Google Authenticator",
    "auth.authenticatorCode": "Kod z aplikacji",
    "auth.newPassword": "Ustaw nowe hasło",
    "auth.newPasswordSubtitle": "Konto wymaga nowego hasła, zanim będzie można kontynuować.",
    "auth.newPasswordLabel": "Nowe hasło",
    "auth.confirmPassword": "Potwierdź hasło",
    "auth.passwordsMismatch": "Hasła muszą być takie same.",
    "auth.savePassword": "Zapisz hasło",
    "auth.resetPassword": "Resetuj hasło",
    "auth.resetPasswordSubtitle": "Wyślemy e-mailem kod, aby ustawić nowe hasło.",
    "auth.resetCodeSent": "Wpisz kod wysłany na {destination}.",
    "auth.resetCodeFallback": "Wpisz kod z e-maila i nowe hasło.",
    "auth.resetCode": "Kod resetujący",
    "auth.updatePassword": "Zmień hasło",
    "auth.codeAndPasswordRequired": "Kod i hasło są wymagane.",
    "auth.smsCode": "Kod SMS",
    "auth.enterCodeSent": "Wpisz kod wysłany na {destination}.",
    "auth.enterCode": "Wpisz kod.",
    "auth.totpCode": "Kod z aplikacji",
    "auth.totpCodeSubtitle": "Wpisz 6-cyfrowy kod z Google Authenticator.",
    "auth.notice.confirmationSent": "Wysłano nowy kod potwierdzający.",
    "auth.notice.smsSent": "Wysłano nowy kod SMS.",
    "auth.notice.passwordUpdated": "Hasło zostało zmienione. Zaloguj się nowym hasłem.",
    "auth.error.generic": "Coś poszło nie tak.",
    "auth.error.secretHash": "Ten klient aplikacji ma sekret. W Cognito utwórz publicznego klienta bez sekretu i wpisz jego identyfikator w .env.local.",
    "auth.error.incorrectCredentials": "Nieprawidłowy e-mail lub hasło.",
    "auth.error.confirmEmail": "Potwierdź e-mail przed zalogowaniem.",
    "auth.error.invalidCode": "Kod jest nieprawidłowy. Spróbuj ponownie.",
    "auth.error.expiredCode": "Kod wygasł. Poproś o nowy.",
    "auth.error.emailExists": "Konto z tym adresem e-mail już istnieje.",
    "auth.error.tooManyAttempts": "Zbyt wiele prób. Odczekaj chwilę i spróbuj ponownie.",
    "auth.error.smsPool": "Ta pula użytkowników nie może jeszcze wysyłać SMS. W Cognito otwórz Messaging i ustaw rolę SNS dla SMS albo wybierz Google Authenticator.",
    "auth.error.notConfigured": "Cognito nie jest skonfigurowane. Dodaj identyfikator puli i klienta aplikacji do .env.local.",
    "auth.error.noSession": "Logowanie nie zwróciło sesji.",
    "auth.error.smsSetup": "Cognito nie wysłało kodu SMS. Numer telefonu na tym koncie musi być zweryfikowany, a SMS MFA włączone w puli użytkowników. Możesz zamiast tego skonfigurować Google Authenticator.",

    "register.title": "Utwórz konto",
    "register.description": "Wypełnij formularz, aby się zarejestrować. Wyślemy kod potwierdzający e-mailem.",
    "register.emailInvalid": "Podaj prawidłowy adres e-mail.",
    "register.phoneInvalid": "Numer telefonu musi być w formacie międzynarodowym, na przykład +48123456789.",
    "register.phoneHint": "Opcjonalne. Wymagane później, jeśli wybierzesz weryfikację SMS.",

    "page.notFound": "Nie znaleziono strony ... ",
    "page.maintenanceTitle": "Trwają prace serwisowe TSL.",
    "page.maintenanceSubtitle": "Dziękujemy za wyrozumiałość.",

    "theme.title": "Motyw",
    "theme.copy": "Przełączaj jasny i ciemny motyw. Wybór jest zapisywany w tej przeglądarce.",
    "theme.dark": "Ciemny",
    "theme.light": "Jasny",
    "theme.switchToLight": "Przełącz na jasny motyw",
    "theme.switchToDark": "Przełącz na ciemny motyw",

    "language.title": "Język",
    "language.copy": "Wybierz język aplikacji. Wybór jest zapisywany w tej przeglądarce.",
    "language.english": "English",
    "language.polish": "Polski",
    "language.switchToEnglish": "Przełącz na angielski",
    "language.switchToPolish": "Przełącz na polski",

    "timezone.title": "Strefa czasowa",
    "timezone.copy": "Przy lokalnym serwerze czasy są takie jak na tym komputerze. Przy serwerze UTC daty są w tej strefie i zapisują się jako UTC.",
    "timezone.label": "Strefa czasowa",
    "timezone.london": "Europa, Londyn",
    "timezone.berlin": "Europa, Berlin",
    "timezone.warsaw": "Europa, Warszawa",
    "timezone.helsinki": "Europa, Helsinki",

    "settings.accountNote": "Wszystkie informacje pochodzą z konta Cognito.",
    "settings.account": "Konto",
    "settings.changePassword": "Zmień hasło",
    "settings.changePasswordCopy": "Po kliknięciu zostaniesz wylogowany i otworzy się strona resetu. Podaj e-mail, a potem kod, który wyślemy, aby ustawić nowe hasło.",
    "settings.userId": "ID użytkownika (lokalna baza)",
    "settings.username": "Nazwa użytkownika",
    "settings.created": "Utworzono",
    "settings.lastUpdate": "Ostatnia aktualizacja",
    "settings.phone": "Telefon",
    "settings.phoneVerified": "Telefon zweryfikowany",
    "settings.emailVerified": "E-mail zweryfikowany",
    "settings.mfa": "MFA",
    "settings.mfaSms": "SMS",
    "settings.mfaAuthenticator": "Aplikacja uwierzytelniająca",

    "user.title": "Użytkownik",
    "user.readOnly": "Dane konta są tylko do odczytu.",
    "user.id": "ID użytkownika",
    "user.username": "Nazwa użytkownika",
    "user.confirmation": "Status potwierdzenia",
    "user.created": "Utworzono",
    "user.updated": "Ostatnia aktualizacja",
    "user.mfa": "MFA",
    "user.enabled": "Włączone",
    "user.role": "Rola",
    "user.cannotDeleteSelf": "Nie możesz usunąć swojego konta z tego widoku. Przejdź do Ustawień.",
    "user.deleteTitle": "Usuń użytkownika",
    "user.deleteMany": "Czy na pewno usunąć {count} użytkowników?",
    "user.deleteOne": "Czy na pewno usunąć użytkownika {name}?",

    "posts.title": "Wpisy",
    "posts.intro": "Ogłoszenia widoczne dla wszystkich. Dodaj wpis albo zaznacz wiersz, żeby go edytować lub usunąć.",
    "posts.create": "Dodaj nowy wpis",
    "posts.updateTitle": "Edytuj wpis",
    "posts.createTitle": "Utwórz wpis",
    "posts.description": "Utwórz lub zaktualizuj wpis. Będzie widoczny dla wszystkich użytkowników.",
    "posts.titleLabel": "Tytuł",
    "posts.titlePlaceholder": "Tytuł wpisu",
    "posts.content": "Treść",
    "posts.contentPlaceholder": "Napisz wpis...",
    "posts.deleteTitle": "Usuń wpis",
    "posts.deleteMany": "Czy na pewno usunąć {count} wpisy?",
    "posts.deleteOne": "Czy na pewno usunąć wpis o ID „{id}”?",

    "customers.title": "Klienci",
    "customers.intro": "To rejestr klientów. Dodaj klienta, otwórz nazwę, żeby go zobaczyć, albo zaznacz wiersz, żeby go usunąć.",
    "customers.add": "Dodaj nowego klienta",
    "customers.createHint": "Nazwa, typ podmiotu, status, role, język i strefa czasowa są wymagane. Strona i notatka do statusu są opcjonalne.",
    "customers.choose": "Wybierz",
    "customers.rolesPlaceholder": "principal, shipper",
    "customers.exampleName": "ABC Logistics sp. z o.o.",
    "customers.exampleWebsite": "https://abc.example",
    "customers.exampleStatusNote": "Klient aktywny.",
    "customers.exampleTaxId": "5251234567",
    "customers.exampleVatEu": "PL5251234567",
    "customers.exampleRegon": "012345678",
    "customers.exampleKrs": "0000123456",
    "customers.exampleCountry": "PL",
    "customers.exampleInvoiceEmail": "faktury@abc.pl",
    "customers.exampleCurrency": "PLN",
    "customers.examplePaymentTerms": "30",
    "customers.examplePaymentMethod": "bank_transfer",
    "customers.exampleIban": "PL61109010140000071219812874",
    "customers.exampleFullName": "Anna Kowalska",
    "customers.exampleJobTitle": "Kierownik transportu",
    "customers.exampleDepartment": "Logistyka",
    "customers.exampleEmail": "anna.kowalska@abc.pl",
    "customers.examplePhone": "+48600123456",
    "customers.exampleLocationType": "warehouse, loading",
    "customers.exampleAddressName": "Magazyn Centralny",
    "customers.exampleNameAtSite": "ABC Logistics DC Pruszków",
    "customers.exampleStreet": "Logistyczna",
    "customers.exampleBuilding": "12",
    "customers.exampleUnit": "A",
    "customers.examplePostalCode": "05-800",
    "customers.exampleCity": "Pruszków",
    "customers.exampleRegion": "mazowieckie",
    "customers.exampleLatitude": "52.1657",
    "customers.exampleLongitude": "20.8031",
    "customers.exampleOpeningHours": "Pn-Pt 06:00-22:00",
    "customers.exampleLoading": "45",
    "customers.exampleUnloading": "30",
    "customers.exampleDriver": "Brama 2, zgłoś się do biura.",
    "customers.examplePpe": "kask, kamizelka",
    "customers.exampleHeight": "4",
    "customers.rolesRequired": "Podaj co najmniej jedną rolę.",
    "customers.websiteInvalid": "Strona musi być adresem http lub https.",
    "customers.entityType": "Typ podmiotu",
    "customers.roles": "Role",
    "customers.website": "Strona",
    "customers.language": "Język",
    "customers.timezone": "Strefa czasowa",
    "customers.statusNote": "Notatka do statusu",
    "customers.legal": "Dane rejestrowe",
    "customers.contacts": "Kontakty",
    "customers.addresses": "Adresy",
    "customers.noLegal": "Brak danych rejestrowych.",
    "customers.noContacts": "Brak kontaktów.",
    "customers.noAddresses": "Brak adresów.",
    "customers.taxId": "NIP",
    "customers.vatEu": "VAT UE",
    "customers.regon": "REGON",
    "customers.krs": "KRS",
    "customers.country": "Kraj",
    "customers.vatStatus": "Status VAT",
    "customers.invoiceEmail": "E-mail do faktur",
    "customers.currency": "Waluta",
    "customers.paymentTerms": "Termin płatności (dni)",
    "customers.paymentMethod": "Metoda płatności",
    "customers.iban": "IBAN",
    "customers.fullName": "Imię i nazwisko",
    "customers.jobTitle": "Stanowisko",
    "customers.department": "Dział",
    "customers.phone": "Telefon",
    "customers.locationType": "Typ lokalizacji",
    "customers.street": "Ulica",
    "customers.city": "Miasto",
    "customers.openingHours": "Godziny otwarcia",
    "customers.appointment": "Wymagana awizacja",
    "customers.driverInstructions": "Instrukcje dla kierowcy",
    "customers.legalTitle": "Informacje prawne",
    "customers.legalHint": "Dane rejestrowe i rozliczeniowe: NIP, VAT, REGON, KRS, kraj, waluta, termin płatności i IBAN.",
    "customers.contactsHint": "Osoby po stronie klienta: imię i nazwisko, stanowisko, dział, e-mail i telefon. Możesz dodać więcej niż jedną.",
    "customers.contactsReadHint": "Te osoby edytujesz na stronie Kontakty.",
    "customers.addressesHint": "Siedziby i punkty: ulica, miasto, kraj, godziny otwarcia i instrukcje dla kierowcy. Możesz dodać więcej niż jeden.",
    "customers.addressesReadHint": "Te miejsca edytujesz na stronie Adresy.",
    "customers.addItem": "Dodaj nowy",
    "customers.building": "Budynek",
    "customers.unit": "Lokal",
    "customers.postalCode": "Kod pocztowy",
    "customers.region": "Region",
    "customers.nameAtSite": "Nazwa na miejscu",
    "customers.latitude": "Szerokość geograficzna",
    "customers.longitude": "Długość geograficzna",
    "customers.loadingTime": "Czas załadunku (min)",
    "customers.unloadingTime": "Czas rozładunku (min)",
    "customers.ppe": "ŚOI",
    "customers.active": "Aktywny",
    "customers.vehicleMega": "Naczepa mega",
    "customers.vehicleHeight": "Maksymalna wysokość (m)",
    "customers.vehicleNight": "Wjazd nocą",
    "customers.countryRequired": "Kraj jest wymagany, gdy uzupełniasz dane rejestrowe albo adres.",
    "customers.countryInvalid": "Kraj to dwuliterowy kod, na przykład PL.",
    "customers.contactNameRequired": "Każdy kontakt potrzebuje imienia i nazwiska.",
    "customers.numberInvalid": "Podaj poprawną liczbę.",
    "customers.deleteTitle": "Usuń klienta",
    "customers.deleteMany": "Czy na pewno usunąć {count} klientów?",
    "customers.deleteOne": "Czy na pewno usunąć klienta „{name}”?",
    "company.title": "Firma",
    "company.emptyDescription": "Nie ma jeszcze danych o firmie. Dodaj nazwę, a potem uzupełnij dane rejestrowe, kontakty i adresy.",
    "company.add": "Dodaj informacje o firmie",
    "company.licenses": "Licencje",
    "company.insurances": "Ubezpieczenia",
    "company.licensesHint": "Licencje na transport drogowy: rodzaj, numer, ważność i organ wydający.",
    "company.insurancesHint": "Polisy OCP, OC i cargo: ubezpieczyciel, numer, suma i ważność.",
    "company.noLicenses": "Brak licencji.",
    "company.noInsurances": "Brak polis.",
    "company.licenseType": "Rodzaj licencji",
    "company.licenseNumber": "Numer licencji",
    "company.issuedOn": "Data wydania",
    "company.validUntil": "Ważna do",
    "company.validFrom": "Ważna od",
    "company.authority": "Organ wydający",
    "company.vehicleLimit": "Limit pojazdów",
    "company.notes": "Uwagi",
    "company.policyType": "Rodzaj polisy",
    "company.policyNumber": "Numer polisy",
    "company.insurer": "Ubezpieczyciel",
    "company.coverage": "Suma gwarancyjna",
    "company.licenseRequired": "Każda licencja potrzebuje rodzaju i numeru.",
    "company.policyRequired": "Każda polisa potrzebuje rodzaju i numeru.",
    "company.dateInvalid": "Podaj datę w formacie RRRR-MM-DD.",
    "company.license.domestic": "Krajowa",
    "company.license.community": "Wspólnotowa",
    "company.license.cabotage": "Kabotaż",
    "company.policy.carrier_liability": "OCP",
    "company.policy.motor": "OC posiadacza",
    "company.policy.cargo": "Cargo",
    "customer.entity.company": "Osoba prawna",
    "customer.entity.sole_trader": "JDG",
    "customer.entity.person": "Osoba fizyczna",
    "customer.status.active": "Aktywny",
    "customer.status.blocked": "Zablokowany",
    "customer.status.archived": "Zarchiwizowany",
    "customer.language.pl": "Polski",
    "customer.language.en": "Angielski",
    "customer.language.de": "Niemiecki",
    "customer.vat.active": "Aktywny",
    "customer.vat.exempt": "Zwolniony",
    "customer.vat.unknown": "Nieznany",

    "vehicles.title": "Pojazdy",
    "vehicles.intro": "To rejestr taboru. Dodaj pojazd, otwórz numer rejestracyjny, żeby go edytować, albo zaznacz wiersz, żeby go usunąć.",
    "vehicles.add": "Dodaj nowy pojazd",
    "vehicles.createHint": "Rejestracja, rodzaj, nazwa i status są wymagane. Numer taboru i notatka są opcjonalne.",
    "vehicles.choose": "Wybierz",
    "vehicles.registration": "Rejestracja",
    "vehicles.fleetCode": "Numer taboru",
    "vehicles.kind": "Rodzaj",
    "vehicles.hauledUnit": "Pojazd ciągniony",
    "vehicles.motorTitle": "Pojazdy silnikowe",
    "vehicles.hauledTitle": "Naczepy i przyczepy",
    "vehicles.assignedMotor": "Przypisany pojazd silnikowy",
    "vehicles.name": "Nazwa",
    "vehicles.exampleRegistration": "WGM 10101",
    "vehicles.exampleFleet": "T-01",
    "vehicles.exampleName": "Volvo FH 500",
    "vehicles.exampleNote": "Ciągnik na linii PL-DE.",
    "trailers.title": "Naczepy",
    "trailers.intro": "Naczepa ma zabudowę i sworzeń. Nie ma silnika, spalania ani kierowcy.",
    "trailers.add": "Dodaj naczepę",
    "trailers.createHint": "Rejestracja, nazwa i status są wymagane. Numer taboru i notatka są opcjonalne.",
    "trailers.exampleName": "Schmitz SCS 24",
    "trailers.technicalHint": "Zabudowa, przestrzeń ładunkowa i sworzeń.",
    "trailers.kingpin": "Wysokość sworznia (mm)",
    "trailers.fifthWheel": "Nacisk na siodło (kg)",
    "trailers.deleteTitle": "Usuń naczepę",
    "trailers.deleteMany": "Czy na pewno usunąć {count} naczep?",
    "trailers.deleteOne": "Czy na pewno usunąć naczepę „{name}”?",
    "drawbars.title": "Przyczepy",
    "drawbars.intro": "Przyczepa jedzie na dyszlu, nie na siodle. Nie ma silnika ani kierowcy.",
    "drawbars.add": "Dodaj przyczepę",
    "drawbars.createHint": "Rejestracja, nazwa i status są wymagane. Sprzęg uzupełnisz na karcie przyczepy.",
    "drawbars.technicalHint": "Zabudowa, przestrzeń ładunkowa i dyszel.",
    "drawbars.couplingTitle": "Sprzęg",
    "drawbars.couplingHint": "Obrotnica albo przyczepa centralnoosiowa.",
    "drawbars.noCoupling": "Brak sprzęgu.",
    "drawbars.couplingType": "Sprzęg",
    "drawbars.drawbarLength": "Długość dyszla (m)",
    "drawbars.hitchHeight": "Wysokość ucha (mm)",
    "drawbars.deleteTitle": "Usuń przyczepę",
    "drawbars.deleteMany": "Czy na pewno usunąć {count} przyczep?",
    "drawbars.deleteOne": "Czy na pewno usunąć przyczepę „{name}”?",
    "drawbar.coupling.turntable": "Z obrotnicą",
    "drawbar.coupling.central_axle": "Centralnoosiowa",
    "vehicles.dateInvalid": "Data w formacie RRRR-MM-DD.",
    "vehicles.numberInvalid": "Podaj poprawną liczbę.",
    "vehicles.addItem": "Dodaj nowy",
    "vehicles.deleteTitle": "Usuń pojazd",
    "vehicles.deleteMany": "Czy na pewno usunąć {count} pojazdów?",
    "vehicles.deleteOne": "Czy na pewno usunąć pojazd „{name}”?",
    "vehicles.technicalTitle": "Profil techniczny",
    "vehicles.technicalHint": "Norma Euro, osie, masy i wymiary zewnętrzne.",
    "vehicles.noTechnical": "Brak profilu technicznego.",
    "vehicles.fuelTitle": "Profil paliwa",
    "vehicles.fuelHint": "Paliwo, AdBlue oraz spalanie z ładunkiem, na pusto i średnie.",
    "vehicles.noFuel": "Brak profilu paliwa.",
    "vehicles.operationalTitle": "Operacje",
    "vehicles.operationalHint": "Baza i GPS.",
    "vehicles.noOperational": "Brak profilu operacyjnego.",
    "vehicles.costsTitle": "Koszty",
    "vehicles.costsHint": "Koszty stałe, budżet okresu i ostatnia faktura.",
    "vehicles.noCosts": "Brak danych kosztowych.",
    "vehicles.assignmentsTitle": "Przypisania naczep i przyczep",
    "vehicles.assignmentsHint": "Ciągnik dostaje jedną naczepę, solówka jedną przyczepę. Pojazd silnikowy staje się gotowy. Imię i nazwisko kierowcy zastępuje ten status.",
    "vehicles.assignHauled": "Przypisz naczepę lub przyczepę",
    "vehicles.assignBlocked": "Pojazd w statusie '{status}' nie może dostać naczepy ani przyczepy.",
    "vehicles.noAssignments": "Brak przypisanej naczepy lub przyczepy.",
    "vehicles.vanNoCoupling": "Bus nie jest łączony z naczepą ani przyczepą.",
    "vehicles.bodyType": "Zabudowa",
    "vehicles.euroClass": "Norma Euro",
    "vehicles.axles": "Osie",
    "vehicles.grossWeight": "DMC (kg)",
    "vehicles.curbWeight": "Masa własna (kg)",
    "vehicles.payload": "Ładowność (kg)",
    "vehicles.length": "Długość (m)",
    "vehicles.width": "Szerokość (m)",
    "vehicles.height": "Wysokość (m)",
    "vehicles.loadingMeters": "Metry ładowne",
    "vehicles.pallets": "Miejsca paletowe",
    "vehicles.volume": "Pojemność (m3)",
    "vehicles.tailLift": "Winda",
    "vehicles.adr": "ADR",
    "vehicles.temperature": "Kontrola temperatury",
    "vehicles.tempMin": "Temperatura min (C)",
    "vehicles.tempMax": "Temperatura max (C)",
    "vehicles.fuelType": "Paliwo",
    "vehicles.tank": "Zbiornik (l)",
    "vehicles.adblueTank": "Zbiornik AdBlue (l)",
    "vehicles.consumption": "Średnie spalanie (l/100 km)",
    "vehicles.consumptionLoaded": "Pełny ładunek (l/100 km)",
    "vehicles.consumptionEmpty": "Na pusto (l/100 km)",
    "vehicles.adblueUse": "AdBlue (l/100 km)",
    "vehicles.homeBase": "Baza",
    "vehicles.gps": "Śledzenie GPS",
    "vehicles.notes": "Notatki",
    "vehicles.currency": "Waluta",
    "vehicles.period": "Okres budżetu",
    "vehicles.leasingCost": "Koszt leasingu",
    "vehicles.insuranceCost": "Koszt ubezpieczenia",
    "vehicles.fixedCost": "Koszty stałe",
    "vehicles.budget": "Budżet",
    "vehicles.invoiceNumber": "Ostatnia faktura",
    "vehicles.invoiceDate": "Data faktury",
    "vehicles.driver": "Kierowca",
    "vehicles.phone": "Telefon",
    "vehicles.assignedFrom": "Data przypisania",
    "vehicles.assignedTo": "Do",
    "vehicles.current": "Aktualne",
    "vehicle.kind.tractor": "Ciągnik",
    "vehicle.kind.rigid": "Solówka",
    "vehicle.kind.trailer": "Przyczepa",
    "vehicle.kind.semitrailer": "Naczepa",
    "vehicle.kind.van": "Bus",
    "vehicle.status.available": "Dostępny",
    "vehicle.status.workshop": "Warsztat",
    "vehicle.status.unavailable": "Niedostępny",
    "vehicle.status.busy": "Zajęty",
    "vehicle.status.ready": "Gotowy",
    "vehicle.body.curtainsider": "Firanka",
    "vehicle.body.box": "Skrzynia",
    "vehicle.body.refrigerated": "Chłodnia",
    "vehicle.body.tanker": "Cysterna",
    "vehicle.body.flatbed": "Platforma",
    "vehicle.body.container": "Kontener",
    "vehicle.body.other": "Inna",
    "vehicle.fuel.diesel": "Diesel",
    "vehicle.fuel.lng": "LNG",
    "vehicle.fuel.cng": "CNG",
    "vehicle.fuel.electric": "Elektryczny",
    "vehicle.fuel.hybrid": "Hybryda",
    "vehicle.period.monthly": "Miesięczny",
    "vehicle.period.yearly": "Roczny",

    "contact.role.dispatcher": "Dyspozytor",
    "contact.role.security": "Ochroniarz",
    "contact.role.other": "Inna",

    "contacts.title": "Kontakty",
    "contacts.intro": "Osoby u klienta: dyspozytorzy, ochrona i inne. Punkt frachtu korzysta z takiego kontaktu.",
    "contacts.add": "Dodaj kontakt",
    "contacts.createHint": "Rola, osoba i e-mail są wymagane. Firma i telefon są opcjonalne.",
    "contacts.editHint": "Zmień tę osobę. Punkty frachtu, które używają kontaktu, pokażą nowe dane.",
    "contacts.customer": "Przynależność",
    "contacts.company": "Przynależność",
    "contacts.role": "Rola",
    "contacts.exampleRole": "Dyspozytor",
    "contacts.fullName": "Imię i nazwisko",
    "contacts.phone": "Telefon",
    "contacts.email": "E-mail",
    "contacts.notes": "Uwagi",
    "contacts.choose": "Wybierz",
    "contacts.deleteTitle": "Usuń kontakt",
    "contacts.deleteOne": "Usunąć {name}?",
    "contacts.deleteMany": "Usunąć {count} kontaktów?",

    "addresses.title": "Adresy",
    "addresses.intro": "Stałe miejsca klientów i firmy: magazyny, siedziby i punkty załadunku.",
    "addresses.location.loading": "Załadunek",
    "addresses.location.unloading": "Rozładunek",
    "addresses.location.headquarters": "Siedziba",
    "addresses.openFrom": "Otwarte od",
    "addresses.openTo": "Otwarte do",
    "addresses.status.open": "Otwarte",
    "addresses.status.closed": "Zamknięte",
    "addresses.add": "Dodaj adres",
    "addresses.createHint": "Kraj jest wymagany. Adres możesz przypisać do klienta albo firmy, albo zostawić bez przypisania.",
    "addresses.editHint": "Zmień to miejsce. Ta sama karta pojawi się u klienta albo w firmie.",
    "addresses.party": "Przynależność",
    "addresses.choose": "Wybierz",
    "addresses.deleteTitle": "Usuń adres",
    "addresses.deleteOne": "Usunąć {name}?",
    "addresses.deleteMany": "Usunąć {count} adresów?",

    "cargo.title": "Ładunki",
    "cargo.intro": "Towar, który można przypisać do frachtu: opakowanie, masa i dane ADR.",
    "cargo.add": "Dodaj ładunek",
    "cargo.createHint": "Opis jest wymagany. Domyślne opakowanie to paleta.",
    "cargo.editHint": "Zmień ten ładunek. Frachty, które go używają, pokażą te same dane.",
    "cargo.choose": "Wybierz",
    "cargo.deleteTitle": "Usuń ładunek",
    "cargo.deleteOne": "Usunąć {name}?",
    "cargo.deleteMany": "Usunąć {count} ładunków?",

    "drivers.title": "Kierowcy",
    "drivers.intro": "Ludzie w taborze: kontakt, umowa i przypisania pojazdów.",
    "drivers.add": "Dodaj nowego kierowcę",
    "drivers.createHint": "Dane identyfikacyjne i kontakt. Umowę i przypisania uzupełnisz na karcie kierowcy.",
    "drivers.choose": "Wybierz",
    "drivers.addItem": "Dodaj wiersz",
    "drivers.deleteTitle": "Usuń kierowcę",
    "drivers.deleteOne": "Usunąć {name}?",
    "drivers.deleteMany": "Usunąć {count} kierowców?",
    "drivers.employeeCode": "Numer kierowcy",
    "drivers.fullName": "Imię i nazwisko",
    "drivers.assignedVehicle": "Przypisany pojazd",
    "drivers.firstName": "Imię",
    "drivers.lastName": "Nazwisko",
    "drivers.phone": "Telefon",
    "drivers.email": "E-mail",
    "drivers.country": "Kraj",
    "drivers.language": "Języki",
    "drivers.exampleCode": "D-04",
    "drivers.examplePhone": "+48500100101",
    "drivers.exampleCountry": "PL",
    "drivers.exampleLanguages": "PL, ENG",
    "drivers.languageInvalid": "Każdy język to kod z 2 lub 3 liter, na przykład PL albo ENG.",
    "drivers.numberInvalid": "Podaj liczbę.",
    "drivers.dateInvalid": "Użyj daty w formacie RRRR-MM-DD.",
    "drivers.countryInvalid": "Kraj to dwuliterowy kod, na przykład PL.",
    "drivers.employmentTitle": "Zatrudnienie",
    "drivers.employmentHint": "Umowa, baza i stawka dzienna netto.",
    "drivers.noEmployment": "Brak danych o zatrudnieniu.",
    "drivers.contractNumber": "Numer umowy",
    "drivers.jobTitle": "Stanowisko",
    "drivers.homeBase": "Baza",
    "drivers.currency": "Waluta",
    "drivers.dailyRate": "Stawka dzienna",
    "drivers.notes": "Uwagi",
    "drivers.metricsTitle": "KPI",
    "drivers.metricsHint": "Naruszenia, spalanie i szkody.",
    "drivers.noMetrics": "Brak KPI.",
    "drivers.violations": "Naruszenia",
    "drivers.lastChecked": "Ostatnia kontrola",
    "drivers.fuel": "Spalanie l/100 km",
    "drivers.damages": "Liczba szkód",
    "drivers.current": "Aktualne",
    "drivers.assignmentsTitle": "Przypisania pojazdów",
    "drivers.assignmentsHint": "Przypisz pojazd silnikowy w statusie gotowy. Jego status zmienia się wtedy na imię i nazwisko kierowcy.",
    "drivers.assignVehicle": "Przypisz pojazd",
    "drivers.assignBlocked": "Kierowcy w statusie '{status}' nie można przypisać pojazdu.",
    "drivers.noAssignments": "Brak przypisań.",
    "drivers.registration": "Rejestracja",
    "drivers.vehicleSet": "Zestaw",
    "drivers.order": "Zlecenie",
    "drivers.assignedFrom": "Data przypisania",
    "drivers.assignedTo": "Do",
    "driver.status.available": "Dostępny",
    "driver.status.unavailable": "Niedostępny",
    "driver.status.ready": "Gotowy",
    "alerts.title": "Alerty",
    "alerts.deleteTitle": "Usuń alert",
    "alerts.deleteMany": "Czy na pewno usunąć {count} alerty?",
    "alerts.deleteOne": "Czy na pewno usunąć alert o ID „{id}”?",

    "dashboard.route.origin": "Adres początkowy",
    "dashboard.route.destination": "Adres końcowy",
    "dashboard.route.originPlaceholder": "Ulica numer, Kod pocztowy Miasto",
    "dashboard.route.destinationPlaceholder": "Ulica numer, Kod pocztowy Miasto",
    "dashboard.cargo.settings": "Ustawienia ładunku",
    "dashboard.cargo.loadingAt": "Data i godzina załadunku",
    "dashboard.cargo.unloadingAt": "Data i godzina rozładunku",
    "dashboard.cargo.loadingTime": "Czas załadunku (min)",
    "dashboard.cargo.unloadingTime": "Czas rozładunku (min)",
    "dashboard.route.settings": "Ustawienia trasy",
    "dashboard.route.performingVehicle": "Pojazd wykonujący trasę",
    "dashboard.route.driver": "Kierowca",
    "dashboard.route.noDriver": "Brak kierowcy",
    "dashboard.route.point": "Adres",
    "dashboard.route.pointPlaceholder": "Ulica numer, Kod pocztowy Miasto",
    "dashboard.route.addPoint": "Dodaj nowy punkt",
    "dashboard.route.removePoint": "Usuń punkt",
    "dashboard.route.dragPoint": "Przeciągnij punkt",
    "dashboard.route.noMatch": "Brak pasującego adresu",
    "dashboard.route.noFreight": "Brak pasującego frachtu",
    "dashboard.route.noVehicle": "Brak pojazdu",
    "dashboard.route.vehicle": "Pojazd",
    "dashboard.route.selectVehicle": "Wybierz",
    "dashboard.route.bus": "Bus",
    "dashboard.route.truck": "Truck",
    "dashboard.route.calculate": "Oblicz trasę",
    "dashboard.route.historyColumn": "Obliczone trasy",
    "dashboard.route.noHistory": "Brak zapisanych tras",
    "dashboard.route.deleteTitle": "Usuń trasę",
    "dashboard.route.sendToDriver": "Wyślij trasę do kierowcy",
    "dashboard.route.sendConfirm": "Czy wysłać tę trasę do kierowcy {name}?",
    "dashboard.route.sendGoogle": "Na Google Maps",
    "dashboard.route.sendHere": "Na HERE WeGo",
    "dashboard.route.hereTruckLicense": "Nawigacja ciężarowa w HERE WeGo wymaga licencji HERE WeGo Pro na telefonie kierowcy. Bez niej aplikacja pokaże trasę samochodową.",
    "dashboard.route.sending": "Wysyłanie...",
    "dashboard.route.sent": "Trasa została wysłana do kierowcy.",
    "dashboard.route.sendFailed": "Nie udało się wysłać trasy.",
    "dashboard.route.deleteOne": "Czy na pewno usunąć trasę „{name}”?",
    "dashboard.route.deleteMany": "Czy na pewno usunąć {count} tras?",
    "dashboard.route.calculating": "Obliczanie...",
    "dashboard.route.distance": "Dystans: {distance} km",
    "dashboard.route.summaryRoute": "Trasa",
    "dashboard.route.summaryLeg": "Odcinek",
    "dashboard.route.summaryDistance": "Dystans",
    "dashboard.route.summaryDuration": "Czas",
    "dashboard.route.estimatedArrival": "Szacowany przyjazd",
    "dashboard.route.estimatedUnloadingEnd": "Szacowany koniec rozładunku",
    "dashboard.route.plannedUnloading": "Względem planu rozładunku",
    "dashboard.route.arrivalOnTime": "Zgodnie z planem",
    "dashboard.route.arrivalLate": "{duration} po planie",
    "dashboard.route.arrivalEarly": "{duration} przed planem",
    "dashboard.route.summaryToll": "Myto",
    "dashboard.route.variant": "Trasa {number} — Opcja {mode}",
    "dashboard.route.mode.fast": "najszybsza",
    "dashboard.route.mode.short": "najkrótsza",
    "dashboard.route.tolls": "Opłaty drogowe",
    "dashboard.route.noTolls": "Brak opłat",
    "dashboard.route.distanceValue": "{distance} km",
    "dashboard.route.durationHours": "Czas: {hours} h {minutes} min",
    "dashboard.route.durationHoursValue": "{hours} h {minutes} min",
    "dashboard.route.durationMinutes": "Czas: {minutes} min",
    "dashboard.route.durationMinutesValue": "{minutes} min",
    "dashboard.route.mapUnavailable": "Mapa jest niedostępna.",
    "dashboard.route.switchMapToDay": "Przełącz mapę na dzień",
    "dashboard.route.switchMapToNight": "Przełącz mapę na noc",
    "dashboard.route.openPoint": "Adres punktu {letter}",
    "dashboard.route.pointTitle": "Punkt {letter}",
    "dashboard.route.matchedAddress": "Rozpoznane miejsce",
    "dashboard.route.pointCoordinates": "Współrzędne",

    "table.edit": "Edytuj",
    "table.delete": "Usuń",
    "table.deleteRecords": "Usuń rekordy",

    "col.id": "ID",
    "col.title": "Tytuł",
    "col.enabled": "Włączone",
    "col.role": "Rola",
    "col.email": "E-mail",
    "col.status": "Status",
    "col.createdShort": "Utworzono",
    "col.updatedShort": "Ostatnia aktualizacja",
    "col.name": "Nazwa",
    "col.messageId": "ID wiadomości",
    "col.dateSent": "Data wysłania",
    "col.actions": "Akcje",

    "code.admin": "Administrator",
    "code.standard": "Standardowy",
    "code.confirmed": "Potwierdzone",
    "code.unconfirmed": "Niepotwierdzone",
    "code.archived": "Zarchiwizowane",
    "code.compromised": "Naruszone",
    "code.unknown": "Nieznany",
    "code.reset_required": "Wymagany reset",
    "code.force_change_password": "Wymuszona zmiana hasła",
    "code.external_provider": "Zewnętrzny dostawca",

    "documents.title": "Dokumenty",
    "documents.hint": "Pliki przypisane do tego rekordu.",
    "documents.drop": "Upuść pliki albo wybierz je z dysku.",
    "documents.choose": "Wybierz pliki",
    "documents.upload": "Upload",
    "documents.download": "Pobierz",
    "documents.downloadFailed": "Nie udało się pobrać pliku.",
    "documents.remove": "Usuń",
    "documents.tooMany": "Można dodać maksymalnie 10 plików.",
    "documents.duplicate": "Ten plik jest już załadowany.",
    "documents.tooLarge": "Plik jest większy niż 20 MB.",
    "documents.uploadFailed": "Wgranie nie powiodło się. Spróbuj ponownie.",
    "documents.status.selected": "Do wgrania",
    "documents.deleteTitle": "Usuń plik",
    "documents.deleteOne": "Czy na pewno usunąć „{name}”?",
    "documents.deleteMany": "Czy na pewno usunąć {count} plików?",

    "settlements.title": "Rozliczenia",
    "settlements.intro": "Wgraj faktury i paragony jako PDF, JPG albo PNG, a potem policz cenę do zapłaty, kwotę netto, VAT i godziny usług. Maksymalnie 10 plików, po 10 MB. Rozliczenie paliwa przyjmuje tylko PDF.",
    "settlements.disabled": "Rozliczenia są wyłączone.",
    "settlements.drop": "Upuść pliki PDF, JPG lub PNG albo wybierz je z dysku.",
    "settlements.choose": "Wybierz pliki",
    "settlements.upload": "Upload",
    "settlements.settle": "Rozlicz",
    "settlements.name": "Nazwa",
    "settlements.namePlaceholder": "Paliwo wrzesień",
    "settlements.taskType": "Rodzaj",
    "settlements.select": "Wybierz",
    "settlements.detailType": "Typ rozliczenia",
    "settlements.created": "Data utworzenia",
    "settlements.completed": "Data zakończenia",
    "settlements.task.rozliczenia": "Rozliczenia faktur",
    "settlements.task.rozliczenia_faktur": "Rozliczenia faktur",
    "settlements.task.rozliczenia_paliwa": "Rozliczenia paliwa",
    "settlements.waiting": "Trwają wyliczenia",
    "settlements.uploadFailed": "Wgranie nie powiodło się. Spróbuj ponownie.",
    "settlements.settleFailed": "Rozliczenie nie powiodło się.",
    "settlements.tooMany": "Można dodać najwyżej 10 plików.",
    "settlements.duplicate": "Ten plik jest już załadowany.",
    "settlements.onlyPdf": "Przyjmowane są tylko pliki PDF, JPG, JPEG i PNG.",
    "settlements.fuelPdfOnly": "Rozliczenie paliwa przyjmuje tylko pliki PDF.",
    "settlements.tooLarge": "Każdy plik musi mieć od 1 bajta do 10 MB.",
    "settlements.remove": "Usuń",
    "settlements.history": "Historia",
    "settlements.deleteTitle": "Usuń rozliczenie",
    "settlements.deleteOne": "Czy na pewno usunąć rozliczenie „{name}”?",
    "settlements.deleteMany": "Czy na pewno usunąć {count} rozliczeń?",
    "settlements.empty": "Brak rozliczeń.",
    "settlements.result": "Wynik",
    "settlements.total": "Suma",
    "settlements.gross": "Brutto",
    "settlements.net": "Netto",
    "settlements.vat": "VAT",
    "settlements.hours": "Godziny",
    "settlements.serviceHours": "Godziny usług",
    "settlements.hoursValue": "{hours} godz.",
    "settlements.missing": "Brakujące dokumenty",
    "settlements.status.selected": "Do wgrania",
    "settlements.status.uploaded": "Wgrany",
    "settlements.jobStatus.processing": "W toku",
    "settlements.jobStatus.completed": "Zakończone",
    "settlements.jobStatus.failed": "Błąd",
    "settlements.error.provider_error": "Usługa rozliczenia nie zwróciła wyniku.",
    "settlements.error.invalid_result": "Wyniku rozliczenia nie udało się odczytać.",

    "freights.title": "Frachty",
    "freights.intro": "Zlecenia transportowe drogowe. Dodaj zlecenie, otwórz jego numer, żeby je edytować, albo zaznacz wiersz, żeby je usunąć.",
    "freights.add": "Dodaj nowy fracht",
    "freights.createHint": "Numer zlecenia, status, cena i waluta są wymagane. Numer zewnętrzny i uwagi są opcjonalne.",
    "freights.choose": "Wybierz",
    "freights.number": "Numer zlecenia",
    "freights.external": "Numer zewnętrzny",
    "freights.notes": "Uwagi",
    "freights.exampleNumber": "ZL/2026/1044",
    "freights.exampleExternal": "PO-4401",
    "freights.exampleNote": "FTL Warszawa–Berlin.",
    "freights.datetimeInvalid": "Data w formacie RRRR-MM-DD albo RRRR-MM-DDTHH:MM:SS.",
    "freights.unloadingBeforeLoading": "Data i godzina rozładunku musi być późniejsza niż data i godzina załadunku.",
    "freights.numberInvalid": "Podaj poprawną liczbę.",
    "freights.countryInvalid": "Kod kraju musi mieć 2 litery.",
    "freights.addItem": "Dodaj nowy",
    "freights.deleteTitle": "Usuń fracht",
    "freights.deleteMany": "Czy na pewno usunąć {count} frachtów?",
    "freights.deleteOne": "Czy na pewno usunąć fracht „{name}”?",
    "freights.stopsTitle": "Punkty",
    "freights.stopsHint": "Załadunek, rozładunek, odprawa celna i postój. Osoba na miejscu to kontakt: imię, rola, telefon, e-mail i klient.",
    "freights.noStops": "Brak punktów.",
    "freights.cargoTitle": "Ładunek",
    "freights.cargoHint": "Przypisz ładunek z katalogu. Opakowanie, masa i ADR zostają na karcie ładunku.",
    "freights.assignCargo": "Przypisz ładunek",
    "freights.addCargo": "Dodaj nowy ładunek",
    "freights.noCargoMatch": "Brak pasującego ładunku",
    "freights.dragCargo": "Przeciągnij ładunek",
    "freights.removeCargo": "Usuń ładunek",
    "freights.noCargo": "Brak przypisanego ładunku.",
    "freights.loadingAt": "Data i godzina załadunku",
    "freights.unloadingAt": "Data i godzina rozładunku",
    "freights.requirementTitle": "Wymagania",
    "freights.requirementHint": "Wymagania dla zestawu, kierowcy i realizacji.",
    "freights.noRequirement": "Brak wymagań.",
    "freights.commercialTitle": "Warunki handlowe",
    "freights.commercialHint": "Termin płatności i postój.",
    "freights.noCommercial": "Brak warunków handlowych.",
    "freights.routeTitle": "Plan trasy",
    "freights.routeHint": "Odcinki: kilometry płatne i puste, czas oraz myto.",
    "freights.noRoute": "Brak odcinków trasy.",
    "freights.customersTitle": "Klient",
    "freights.customersHint": "Przypisz klienta, do którego należy ten fracht.",
    "freights.assignCustomer": "Przypisz klienta",
    "freights.noCustomers": "Brak przypisanego klienta.",
    "freights.driversTitle": "Kierowcy",
    "freights.driversHint": "Przypisz kierowcę ze statusem Gotowy. Jego aktualny pojazd jest pojazdem frachtu. Fracht przechodzi na „W trasie”, a status kierowcy przyjmuje numer tego zlecenia. Status „Szkic” albo „Zaplanowany” odpina kierowcę i przywraca mu status „Gotowy”.",
    "freights.assignDriver": "Przypisz kierowcę",
    "freights.noDrivers": "Brak przypisanych kierowców.",
    "freights.executionTitle": "Wykonanie",
    "freights.executionHint": "Rzeczywisty załadunek, wyjazd, dostawa i opóźnienie.",
    "freights.noExecution": "Brak danych wykonania.",
    "freights.estimatesTitle": "Koszty planowane",
    "freights.estimatesHint": "Planowane pozycje kosztu kursu.",
    "freights.noEstimates": "Brak planowanych kosztów.",
    "freights.actualsTitle": "Koszty rzeczywiste",
    "freights.actualsHint": "Koszty zapisane po kursie.",
    "freights.noActuals": "Brak rzeczywistych kosztów.",
    "freights.claimsTitle": "Reklamacje",
    "freights.claimsHint": "Szkoda, opóźnienie, brak albo inne obciążenie.",
    "freights.noClaims": "Brak reklamacji.",
    "freights.sequence": "Kolejność",
    "freights.stopType": "Rodzaj punktu",
    "freights.contact": "Kontakt",
    "freights.contactName": "Osoba",
    "freights.contactRole": "Rola",
    "freights.contactPhone": "Telefon",
    "freights.contactEmail": "E-mail",
    "freights.stopCustomer": "Klient",
    "freights.stopName": "Nazwa miejsca",
    "freights.street": "Ulica",
    "freights.postalCode": "Kod pocztowy",
    "freights.city": "Miasto",
    "freights.country": "Kraj",
    "freights.plannedArrival": "Planowany przyjazd",
    "freights.plannedDeparture": "Planowany wyjazd",
    "freights.instructions": "Wskazówki",
    "freights.description": "Opis",
    "freights.packaging": "Opakowanie",
    "freights.quantity": "Ilość",
    "freights.weight": "Masa (kg)",
    "freights.volume": "Objętość (m3)",
    "freights.loadingMeters": "Metry ładowne",
    "freights.adrInfo": "Dane ADR",
    "freights.unNumber": "Numer UN",
    "freights.packingGroup": "Grupa pakowania",
    "freights.vehicleKind": "Rodzaj pojazdu",
    "freights.bodyType": "Zabudowa",
    "freights.requiresAdr": "Wymagane ADR",
    "freights.tailLift": "Wymagana winda",
    "freights.minPayload": "Min. ładowność (kg)",
    "freights.driverLanguage": "Język kierowcy",
    "freights.price": "Cena",
    "freights.currency": "Waluta",
    "freights.paymentDays": "Termin płatności (dni)",
    "freights.waitingHours": "Postój w cenie (h)",
    "freights.waitingRate": "Stawka postoju",
    "freights.termsNote": "Uwagi do warunków",
    "freights.origin": "Początek",
    "freights.destination": "Koniec",
    "freights.distance": "Dystans (km)",
    "freights.paidKm": "Km płatne",
    "freights.emptyKm": "Km puste",
    "freights.duration": "Czas (min)",
    "freights.toll": "Myto",
    "freights.tollCurrency": "Waluta myta",
    "freights.driverId": "Id kierowcy",
    "freights.customerId": "Id klienta",
    "freights.assignedFrom": "Data przypisania",
    "freights.current": "Aktualne",
    "freights.loadedAt": "Załadunek",
    "freights.departedAt": "Wyjazd",
    "freights.deliveredAt": "Dostawa",
    "freights.delayReason": "Powód opóźnienia",
    "freights.delayMinutes": "Opóźnienie (min)",
    "freights.delayCost": "Koszt opóźnienia",
    "freights.delayCurrency": "Waluta opóźnienia",
    "freights.costType": "Rodzaj kosztu",
    "freights.amount": "Kwota",
    "freights.note": "Notatka",
    "freights.claimType": "Rodzaj reklamacji",
    "freights.claimStatus": "Status reklamacji",
    "freights.claimDescription": "Opis",
    "freights.openedOn": "Data zgłoszenia",
    "freights.closedOn": "Data zamknięcia",
    "freight.status.draft": "Szkic",
    "freight.status.planned": "Zaplanowany",
    "freight.status.in_transit": "W trasie",
    "freight.status.delivered": "Dostarczony",
    "freight.status.cancelled": "Anulowany",
    "freight.status.closed": "Zamknięty",
    "freight.stop.loading": "Załadunek",
    "freight.stop.unloading": "Rozładunek",
    "freight.stop.customs": "Odprawa celna",
    "freight.stop.rest": "Postój",
    "freight.packaging.pallet": "Paleta",
    "freight.packaging.carton": "Karton",
    "freight.packaging.big_bag": "Big-bag",
    "freight.packaging.container": "Pojemnik",
    "freight.packaging.other": "Inne",
    "freight.cost.fuel": "Paliwo",
    "freight.cost.toll": "Myto",
    "freight.cost.parking": "Parking",
    "freight.cost.driver": "Kierowca",
    "freight.cost.subcontract": "Podwykonawca",
    "freight.cost.other": "Inne",
    "freight.claimType.damage": "Szkoda",
    "freight.claimType.delay": "Opóźnienie",
    "freight.claimType.shortage": "Brak",
    "freight.claimType.other": "Inne",
    "freight.claimStatus.open": "Otwarta",
    "freight.claimStatus.accepted": "Uznana",
    "freight.claimStatus.rejected": "Odrzucona",
    "freight.claimStatus.closed": "Zamknięta",

    "agent.title": "Agent AI",
    "agent.intro": "Agent liczy rentowność wybranego frachtu. Bierze z TMS cenę, kilometry, paliwo, myto, parking, pensję i dietę, a Perplexity wylicza koszt i marżę w EUR.",
    "agent.disabled": "Agent AI jest wyłączony.",
    "agent.parameters": "Parametry Agenta",
    "agent.task": "Zadanie do Agenta",
    "agent.freight": "Fracht",
    "agent.name": "Nazwa",
    "agent.namePlaceholder": "Stawki październik",
    "agent.select": "Wybierz",
    "agent.task.calculate_freight": "Oblicz fracht",
    "agent.startAt": "Czas uruchomienia",
    "agent.frequencyTitle": "Częstotliwość pracy Agenta",
    "agent.frequencyHint": "Jednostka i wartość określają, co ile agent powtarza wyliczenie po pierwszym uruchomieniu. Na przykład 10 minut albo 2 godziny.",
    "agent.timeUnit": "Jednostka czasu",
    "agent.unit.minutes": "Minuty",
    "agent.unit.hours": "Godziny",
    "agent.value": "Wartość",
    "agent.frequency": "Częstotliwość",
    "agent.minutesCount": "{count} min",
    "agent.hoursCount": "{count} godz.",
    "agent.history": "Historia",
    "agent.deleteTitle": "Usuń uruchomienie",
    "agent.deleteOne": "Czy na pewno usunąć uruchomienie „{name}”?",
    "agent.deleteMany": "Czy na pewno usunąć {count} uruchomień?",
    "agent.deleteRunning": "Najpierw zatrzymaj agenta. Uruchomienia w toku nie można usunąć.",
    "agent.result": "Wynik",
    "agent.resultTitle": "Wynik {id} dla {name}",
    "agent.results": "Wyniki",
    "agent.calculatedAt": "Wykonano",
    "agent.summary": "Podsumowanie",
    "agent.resultMissing": "Nie znaleziono tego wyliczenia.",
    "agent.lastRun": "Ostatnie wywołanie",
    "agent.noResult": "Wyliczenie jeszcze się nie odbyło.",
    "agent.missing": "Nie znaleziono tego uruchomienia agenta.",
    "agent.revenue": "Przychód",
    "agent.fuel": "Paliwo",
    "agent.toll": "Myto",
    "agent.parking": "Parking",
    "agent.salary": "Pensja",
    "agent.allowance": "Dieta",
    "agent.cost": "Koszt",
    "agent.margin": "Marża",
    "agent.marginPercent": "Marża %",
    "agent.status.scheduled": "Zaplanowane",
    "agent.status.running": "W toku",
    "agent.status.stopped": "Zatrzymane",
    "agent.error.provider_error": "Usługa wyliczenia nie zwróciła wyniku.",
    "agent.error.invalid_result": "Wyniku wyliczenia nie udało się odczytać.",
    "agent.start": "Uruchom Agenta",
    "agent.stop": "Zatrzymaj Agenta",
    "agent.started": "Agent został uruchomiony. Pierwsze wyliczenie zacznie się o podanym czasie.",
    "agent.stopped": "Agent został zatrzymany.",
    "agent.running": "Agent pracuje.",
    "agent.failed": "Nie udało się uruchomić agenta.",

    "menu.emailImport": "Import maili",
    "email.title": "Import maili",
    "email.intro": "Wiadomości przekazane na adres importu. Czysty import tworzy szkic zlecenia widoczny w Frachtach.",
    "email.disabled": "Import maili jest wyłączony.",
    "email.subject": "Temat",
    "email.sender": "Nadawca przekazania",
    "email.received": "Odebrano",
    "email.attachments": "Załączniki",
    "email.freight": "Zlecenie",
    "email.openFreight": "Otwórz zlecenie",
    "email.noFreight": "Brak zlecenia",
    "email.status.imported": "Zaimportowane",
    "email.status.rejected": "Odrzucone",
    "email.status.quarantine": "Kwarantanna",
    "email.reason.verdicts": "Kontrola bezpieczeństwa",
    "email.reason.disabled_address": "Adres importu jest wyłączony",
    "email.reason.too_large": "Wiadomość jest za duża",
    "email.reason.unparseable": "Wiadomości nie udało się odczytać",
    "email.body": "Treść",
    "email.htmlPreview": "Podgląd HTML",
    "email.noBody": "Ta wiadomość nie ma treści tekstowej.",
    "email.verdicts": "Kontrole SES",
    "email.verdictsHint": "PASS nie jest gwarancją bezpieczeństwa.",
    "email.verdict.spamVerdict": "Spam",
    "email.verdict.virusVerdict": "Wirus",
    "email.verdict.spfVerdict": "SPF",
    "email.verdict.dkimVerdict": "DKIM",
    "email.verdict.dmarcVerdict": "DMARC",
    "email.filename": "Plik",
    "email.type": "Typ",
    "email.size": "Rozmiar",
    "email.download": "Pobierz",
    "email.notDownloadable": "Niedostępny",
    "email.downloadFailed": "Nie udało się pobrać pliku.",
    "email.missing": "Nie znaleziono tej wiadomości.",
    "email.empty": "Nie ma jeszcze zaimportowanych wiadomości.",
    "email.truncated": "Widoczne jest ostatnie {count} z {total}.",
    "email.originalId": "Oryginalny Message-ID",
    "email.fromMail": "Z importu maili",
};

export const messages = { en, pl };
